import { useEffect, useState } from 'react';
import { Link, Navigate as Redirect } from 'react-router-dom';
import BTCLogo from './images/btc.svg';
import BCHLogo from './images/bch.svg';
import ETHLogo from './images/eth.svg';
import LTCLogo from './images/ltc.svg';
import USDTLogo from './images/usdt.svg';
import CRYPTOLogo from './images/cryptos.png';
import TradeSwitch from './TradeSwitch';
import DashboardParam from './DashboardParam';
import DashboardNavBar from './DashboardNavBar';
import DashboardNavBar2 from './DashboardNavBar2';
import FullLoader from './FullLoader';
import bankOptions from './bankOptions';

const DashboardView = ({ onPostSell, onPostBuy, onPostDeposit, onPostWithdraw, onPostQuickSellBTC, onPostQuickSellUSDT, onPostQuickSellALT, onPostSendBTC, onPostSendUSDT, onPostSendALT, alertMessage, nameLookUp, fetchBankName}) => {
	
	var websocket, response, obj, wsUri = "wss://endopay.com:1060";	
	
	const [fullname, setFullName] = useState('');
	
	const [sendbtcdir, setSendBTCdir] = useState('USD');
	const [sendusdtdir, setSendUSDTdir] = useState('USD');
	const [sendbchdir, setSendBCHdir] = useState('USD');
	const [sendethdir, setSendETHdir] = useState('USD');
	const [sendltcdir, setSendLTCdir] = useState('USD');
	
	const [quicksellbtcdir, setQuickSellBTCdir] = useState('USD');	
	const [quicksellusdtdir, setQuickSellUSDTdir] = useState('USD');	
	const [quicksellbchdir, setQuickSellBCHdir] = useState('USD');
	const [quicksellethdir, setQuickSellETHdir] = useState('USD');
	const [quicksellltcdir, setQuickSellLTCdir] = useState('USD');
	const [withdrawamount, setWithdrawAmount] = useState('');
	
	const [quicksellbtcamount, setQuickSellBTCAmount] = useState('');	
	const [quicksellusdtamount, setQuickSellUSDTAmount] = useState('');	
	const [quicksellbchamount, setQuickSellBCHAmount] = useState('');
	const [quicksellethamount, setQuickSellETHAmount] = useState('');
	const [quicksellltcamount, setQuickSellLTCAmount] = useState('');
	
	const [sendbtcamount, setSendBTCAmount] = useState('');
	const [sendusdtamount, setSendUSDTAmount] = useState('');
	const [sendbchamount, setSendBCHAmount] = useState('');
	const [sendethamount, setSendETHAmount] = useState('');
	const [sendltcamount, setSendLTCAmount] = useState('');
	
	const [sellamount, setSellAmount] = useState('');
	const [buyamount, setBuyAmount] = useState('');
	const [depositamount, setDepositAmount] = useState('');
	
	const [sellcurrency, setSellCurrency] = useState('');	
	const [sellcurrencydir, setSellCurrencydir] = useState('USD');
	
	//const [buyaccount, setBuyAccount] = useState('');
	const [buycurrency, setBuyCurrency] = useState('');
	const [buycurrencydir, setBuyCurrencydir] = useState('USD');
	const [buymethod, setBuyMethod] = useState('');
	
	const [depositcurrency, setDepositCurrency] = useState('');
	const [depositcurrencydir, setDepositCurrencydir] = useState('USD');	
	const [dashboardparams, setDashboardParams] = useState([]);
	
	const [verify, setVerify] = useState('0');
	
	useEffect(() => {
		var thisobj, user, key;
		setFullName(fullname);		
		user = localStorage.getItem('useremail');
		key = localStorage.getItem('_key');
		thisobj = {'rtype': 'userlookup', 'email': user, 'key': key};
		localStorage.setItem("objall2", JSON.stringify(thisobj));
		localStorage.setItem("obj2", JSON.stringify(thisobj));
		localStorage.setItem("objname2", thisobj.rtype);
		doCheck();
		// eslint-disable-next-line
	},[]);
	
	function doCheck()
	{
		endoSocket();
	}
	
	function endoSocket()
	{
		websocket = new WebSocket(wsUri);
		websocket.onopen = function(evt) { onOpen(evt) };
		websocket.onclose = function(evt) { onClose(evt) };
		websocket.onmessage = function(evt) { onMessage(evt) };
		websocket.onerror = function(evt) { onError(evt) };
	}
	
	function onOpen(evt)
	{		
		obj = localStorage.getItem("obj2");
		if(obj){
			doSend(obj);
		}
	}
	
	function onClose(evt)
	{
		
	}
	
	function onMessage(evt)
	{
		response = evt.data; 
		if(JSON.parse(response))
		{
			console.log(response);
			response = JSON.parse(response);
			if(localStorage.getItem("objname2") && localStorage.getItem("objname2") === 'userlookup')
			{
				setDashboardParams(response);
				localStorage.setItem('bankacct', dashboardparams.bankacct);
				if(response['key']){
					localStorage.setItem('_key', response['key']);
				}
				
				if(response['msg'])
				{
					
					alert(response['msg']);
					if(response['msg'] === 'Please Relogin'){
						localStorage.setItem('useremail', '');
						localStorage.clear();
						localStorage.setItem('maincontainer', 'maincontainer');
						window.location.assign("/signin");
					}
				}
				else
				{	
					if(response['bankacct'] && response['bankverify'])
					{
						setVerify(response['bankverify']);
						localStorage.setItem("class", response["class"]);
						if(response["class"] && response["class"] === '1'){
							localStorage.setItem("api", response["api"]);
							localStorage.setItem("apikey", response["apikey"]);
							localStorage.setItem("apiip", response["apiip"]);
						}else{
							localStorage.setItem("api", '');
							localStorage.setItem("apikey", '');
							localStorage.setItem("apiip", '');
						}
						localStorage.setItem("phone", response["phone"]);
						localStorage.setItem("fullname", response['firstname']+" "+response['lastname']);
						setFullName(localStorage.getItem('fullname'));
						localStorage.setItem("setcode", response['setcode']);
						localStorage.setItem("bankverify", response['bankverify']);
						localStorage.setItem("banktitle", '');
						localStorage.setItem("bankmemo", '');
						if(response['otherbank'])
						{
							localStorage.setItem("otherbank", response['otherbank']);
						}else{
							localStorage.setItem("otherbank", '');
						}
						if(response['bankacct'])
						{
							localStorage.setItem("bankacct", response['bankacct']);
							localStorage.setItem("bankabbr", response['bankabbr']);
						}else{
							localStorage.setItem("bankacct", '');
							localStorage.setItem("bankabbr", '');
						}
						localStorage.setItem("ngnbal", response["ngnbal"]);
						localStorage.setItem("btcwallet", response["btcwallet"]);
						localStorage.setItem("btcwalletbal", response["btcwalletbal"]);
						localStorage.setItem("usdtwallet", response["usdtwallet"]);
						localStorage.setItem("usdtwalletbal", response["usdtwalletbal"]);
						localStorage.setItem("ltcwallet", response["ltcwallet"]);
						localStorage.setItem("ltcwalletbal", response["ltcwalletbal"]);
						localStorage.setItem("ethwallet", response["ethwallet"]);
						localStorage.setItem("ethwalletbal", response["ethwalletbal"]);
						localStorage.setItem("bchwallet", response["bchwallet"]);
						localStorage.setItem("bchwalletbal", response["bchwalletbal"]);
						document.getElementById('ngnbaldisplay').innerHTML = 'Available Balance: <b>'+response["ngnbal"]+'</b>';					
						document.getElementById('receivebtcdisplay').className= 'addressdisplay';
						document.getElementById('receiveusdtdisplay').className= 'addressdisplay';
						document.getElementById('receivebchdisplay').className= 'addressdisplay';
						document.getElementById('receiveltcdisplay').className= 'addressdisplay';
						document.getElementById('receiveethdisplay').className= 'addressdisplay';
						
						document.getElementById('receivebtcdisplay').innerHTML = '<span key="dashspanbtc" id="receivebtcaddressInfo"><font class="messages__time2"><b>'+response["btcwallet"]+'</b></font></span><br/><span key="qrbtc" id="qrcodeTableBTC"><img src="https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl='+response["btcwallet"]+'" alt=""/></span>';
						document.getElementById('receiveusdtdisplay').innerHTML = '<span key="dashspanusdt" id="receiveusdtaddressInfo"><font class="messages__time2"><b>'+response["usdtwallet"]+'</b></font></span><br/><span key="qrusdt" id="qrcodeTableUSDT"><img src="https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl='+response["usdtwallet"]+'" alt=""/></span>';
						//document.getElementById('receiveltcdisplay').innerHTML = '<span key="dashspanltc" id="receiveltcaddressInfo">Available Soon...</span>';
						//document.getElementById('receivebchdisplay').innerHTML = '<span key="dashspanbch" id="receivebchaddressInfo">Available Soon...</span>';
						//document.getElementById('receiveethdisplay').innerHTML = '<span key="dashspaneth" id="receiveethaddressInfo">Available Soon...</span>';
						
						document.getElementById('receivebtcproceed').innerHTML = response["btcwalletbal"];
						document.getElementById('availableBTC1').innerHTML = 'Bal: <b>'+response["btcwalletbal"]+'</b>';
						document.getElementById('availableBTC2').innerHTML = 'Bal: <b>'+response["btcwalletbal"]+'</b>';
						
						document.getElementById('receiveusdtproceed').innerHTML = response["usdtwalletbal"];
						document.getElementById('availableUSDT1').innerHTML = 'Bal: <b>'+response["usdtwalletbal"]+'</b>';
						document.getElementById('availableUSDT2').innerHTML = 'Bal: <b>'+response["usdtwalletbal"]+'</b>';
						
						let elementsToUpdate = [						
							'receiveltcproceed',
							'availableLTC1',
							'availableLTC2',
							'receivebchproceed',
							'availableBCH1',
							'availableBCH2',
							'receiveethproceed',
							'availableETH1',
							'availableETH2'
						];

						for (let i = 0; i < elementsToUpdate.length; i++) {
							const currentElement = document.getElementById(elementsToUpdate[i]);
							if (currentElement) {
								currentElement.innerHTML = '';
							}
						}
						
					}
					else
					{
						setVerify('0');
						localStorage.setItem("class", response["class"]);
						if(response["class"] && response["class"] === '1'){
							localStorage.setItem("api", response["api"]);
							localStorage.setItem("apikey", response["apikey"]);
							localStorage.setItem("apiip", response["apiip"]);
						}else{
							localStorage.setItem("api", '');
							localStorage.setItem("apikey", '');
							localStorage.setItem("apiip", '');
						}
						localStorage.setItem("phone", response["phone"]);
						localStorage.setItem("fullname", response['firstname']+" "+response['lastname']);
						setFullName(localStorage.getItem('fullname'));
						localStorage.setItem("setcode", response['setcode']);
						localStorage.setItem("bankverify", '0');
						localStorage.setItem("banktitle", response["banktitle"]);
						if(response['bankmemo'])
						{
							localStorage.setItem("bankmemo", response["bankmemo"]);
						}else{
							localStorage.setItem("bankmemo", '');
						}
						
						if(response['otherbank'])
						{
							localStorage.setItem("otherbank", response['otherbank']);
						}else{
							localStorage.setItem("otherbank", '');
						}
						if(response['bankacct'])
						{
							localStorage.setItem("bankacct", response['bankacct']);
							localStorage.setItem("bankabbr", response['bankabbr']);
						}else{
							localStorage.setItem("bankacct", '');
							localStorage.setItem("bankabbr", '');
						}
						if(response['bankverify'] !== '0')
						{
							localStorage.setItem("ngnbal", '');
							localStorage.setItem("btcwallet", '');
							localStorage.setItem("btcwalletbal", '');
							localStorage.setItem("usdtwallet", '');
							localStorage.setItem("usdtwalletbal", '');
							localStorage.setItem("ltcwallet", '');
							localStorage.setItem("ltcwalletbal", '');
							localStorage.setItem("ethwallet", '');
							localStorage.setItem("ethwalletbal", '');
							localStorage.setItem("bchwallet", '');
							localStorage.setItem("bchwalletbal", '');
							document.getElementById('ngnbaldisplay').innerHTML = 'Available Balance: <b>'+response["ngnbal"]+'</b>';					
							document.getElementById('receivebtcdisplay').className= 'addressdisplay';
							document.getElementById('receiveusdtdisplay').className= 'addressdisplay';
							document.getElementById('receivebchdisplay').className= 'addressdisplay';
							document.getElementById('receiveltcdisplay').className= 'addressdisplay';
							document.getElementById('receiveethdisplay').className= 'addressdisplay';
							
							document.getElementById('receivebtcdisplay').innerHTML = '<span key="dashspanbtc" id="receivebtcaddressInfo"><font class="messages__time2"><b>'+response["btcwallet"]+'</b></font></span><br/><span key="qrbtc"  id="qrcodeTableBTC"><img src="https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl='+response["btcwallet"]+'" alt=""/></span>';
							
							document.getElementById('receiveusdtdisplay').innerHTML = '<span key="dashspanusdt" id="receiveusdtaddressInfo"><font class="messages__time2"><b>'+response["usdtwallet"]+'</b></font></span><br/><span key="qrusdt"  id="qrcodeTableUSDT"><img src="https://chart.googleapis.com/chart?chs=250x250&cht=qr&chl='+response["usdtwallet"]+'" alt=""/></span>';
							
							//document.getElementById('receiveltcdisplay').innerHTML = '<span key="dashspanltc" id="receiveltcaddressInfo">Available Soon...</span>';
							//document.getElementById('receivebchdisplay').innerHTML = '<span key="dashspanbch" id="receivebchaddressInfo">Available Soon...</span>';
							//document.getElementById('receiveethdisplay').innerHTML = '<span key="dashspaneth" id="receiveethaddressInfo">Available Soon...</span>';
							
							
							let elementsToUpdate = [
								'receivebtcproceed',
								'availableBTC1',
								'availableBTC2',
								'receiveusdtproceed',
								'availableUSDT1',
								'availableUSDT2',
								'receiveltcproceed',
								'availableLTC1',
								'availableLTC2',
								'receivebchproceed',
								'availableBCH1',
								'availableBCH2',
								'receiveethproceed',
								'availableETH1',
								'availableETH2'
							];

							for (let i = 0; i < elementsToUpdate.length; i++) {
								const currentElement = document.getElementById(elementsToUpdate[i]);
								if (currentElement) {
									currentElement.innerHTML = '';
								}
							}

						}
					}					
					
					websocket.close();
				}
			
			}
			else
			{
				console.log(response);
			}
		}else{
			console.log('2');
			websocket.close();
			return false;
		}
		websocket.close();
	}
	
	function onError(evt)
	{
		websocket.close();
	}
	
	function doSend(message)
	{
		websocket.send(message);
		if(message && message !== ''){			
			try{
				if(!websocket.send(message)){
					throw new Error("Endopay Dashboard");
				}
			}catch(e){
				if(e.message === "Failed to execute 'send' on 'WebSocket': Still in CONNECTING state.")
				{
					console.log(message);
				}
			}
		}
		return false;
	}
	
	const cryptoarr = ['BTC', 'BCH', 'LTC', 'ETH', 'BTCEN'];
	const cryptoaltarr = ['BCH', 'LTC', 'ETH'];
	const giftcardarr = ['IT', 'GP'];
	var output;
	
	//ONCURRENCY CHANGE *Amount, Placeholder*
	var sellprealt, sellcur = sellcurrency.toLowerCase()	
	if(cryptoarr.indexOf(sellcurrency) !== -1 && document.getElementById('sellcurrencydirswitch'))
	{	
		document.getElementById('sellcurrencydirswitch').className = 'disshow';
		document.getElementById('sellcurrencydirdisplay').innerHTML = sellcurrency;
		document.getElementById('sellaccountname').value = ((document.getElementById('sellcurrency').options[document.getElementById('sellcurrency').selectedIndex].text).split(' - '))[1];
		document.getElementById('sellfeedback').innerHTML = '';
		document.getElementById('sellfeedback').className = 'incsizespan center';
		if(document.getElementById('sellcurrencydir').checked){
			document.getElementById('sellamount').setAttribute('placeholder', 'Amount In '+sellcurrency);
			document.getElementById('sellcurrencydir').value = sellcurrency;
		}else{
			document.getElementById('sellamount').setAttribute('placeholder', 'Amount In USD');
			document.getElementById('sellcurrencydir').value = 'USD';
		}
		
		if(sellcurrency){
            if(sellcur !== 'btc'){
				sellprealt = localStorage.getItem("sellcur");
				if(sellprealt === sellcur){
					sellcur = 'alt';
					SkyCalculate(sellcur, 'cc', 'sellamount', 'sellsummary');
				}else{
					localStorage.setItem("sellcur", sellcur);
					sellcur = 'alt';
					setTimeout(function(){ SkyCalculate(sellcur, 'cc', 'sellamount', 'sellsummary'); }, 800);	
				}
			}else{
				//SkyCalculate(sellcur, 'cc', 'sellamount', 'sellsummary');
			}		
			document.getElementById('sellratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('sell'+sellcur+'rate').value)+'</b>';
			document.getElementById('minselldisplay').innerHTML = '<b>$'+(document.getElementById('sell'+sellcur+'min').value)+'</b>';
			document.getElementById('maxselldisplay').innerHTML = '<b>$'+(document.getElementById('sell'+sellcur+'max').value)+'</b>';		
		}
	}else if(cryptoarr.indexOf(sellcurrency) === -1 && document.getElementById('sellcurrencydirswitch')){
		document.getElementById('sellcurrencydirswitch').className = 'hide';
		document.getElementById('sellamount').setAttribute('placeholder', 'Amount In USD');
		document.getElementById('sellcurrencydir').value = 'USD';
		document.getElementById('sellfeedback').innerHTML = '';
		document.getElementById('sellfeedback').className = 'incsizespan center';
		
		if(sellcurrency){
			if(sellcur !== 'pm' && sellcur !== 'usdt'){sellcur = 'alt';}
			document.getElementById('sellaccountname').value = ((document.getElementById('sellcurrency').options[document.getElementById('sellcurrency').selectedIndex].text).split(' - '))[1];
			document.getElementById('sellratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('sell'+sellcur+'rate').value)+'</b>';
			document.getElementById('minselldisplay').innerHTML = '<b>$'+(document.getElementById('sell'+sellcur+'min').value)+'</b>';
			document.getElementById('maxselldisplay').innerHTML = '<b>$'+(document.getElementById('sell'+sellcur+'max').value)+'</b>';
			SkyCalculate(sellcur, 'cc', 'sellamount', 'sellsummary');
		}else{
			document.getElementById('sellsummary').style.display = 'none';
			document.getElementById('sellratedisplay').innerHTML = '';
			document.getElementById('minselldisplay').innerHTML = '';
			document.getElementById('maxselldisplay').innerHTML = '';
		}
	}
	

	var buyprealt, addedrate, buycur = buycurrency.toLowerCase();
	if(cryptoarr.indexOf(buycurrency) !== -1 && document.getElementById('buycurrencydirswitch'))
	{	
		document.getElementById('buyaccountcamera').className = 'camera icon-camera';
		document.getElementById('buycurrencydirswitch').className = 'disshow';
		document.getElementById('buycurrencydirdisplay').innerHTML = buycurrency;
		document.getElementById('buyaccountname').value = ((document.getElementById('buycurrency').options[document.getElementById('buycurrency').selectedIndex].text).split(' - '))[1];
		document.getElementById('buyfeedback').innerHTML = '';
		document.getElementById('buyfeedback').className = 'incsizespan center';
		document.getElementById('buyeth').innerHTML = '';
		document.getElementById('buyeth').className = 'incsizespan center';
		document.getElementById('buyeth').style.display = 'none';
		
		if(buymethod === 'CC'){
			addedrate = parseFloat(document.getElementById('addedrate').value);
		}else{
			addedrate = 0;
		}		
		
		if(buycur === 'btc'){
			document.getElementById('buyratedisplay').innerHTML = '<b>&#8358;'+(parseFloat(document.getElementById('buy'+buycur+'rate').value) + addedrate)+'</b>';
			document.getElementById('minbuydisplay').innerHTML = '<b>$'+(document.getElementById('buy'+buycur+'min').value)+'</b>';
			document.getElementById('maxbuydisplay').innerHTML = '<b>$'+(document.getElementById('buy'+buycur+'max').value)+'</b>';
			document.getElementById('buyaccount').style.display = 'block';
			document.getElementById('buyaccount').setAttribute('placeholder', buycurrency+' Address');
			if(document.getElementById('buycurrencydir').checked){
				document.getElementById('buyamount').setAttribute('placeholder', 'Amount In '+buycurrency);
				document.getElementById('buycurrencydir').value = buycurrency;
			}else{
				document.getElementById('buyamount').setAttribute('placeholder', 'Amount In USD');
				document.getElementById('buycurrencydir').value = 'USD';
			}
		}else if(giftcardarr.indexOf(buycurrency) !== -1){			
			document.getElementById('buyratedisplay').innerHTML = '<b>&#8358;'+(parseFloat(document.getElementById('buygiftrate').value) + addedrate)+'</b>';
			document.getElementById('minbuydisplay').innerHTML = '<b>$'+(document.getElementById('buygiftmin').value)+'</b>';
			document.getElementById('maxbuydisplay').innerHTML = '<b>$'+(document.getElementById('buygiftmax').value)+'</b>';
			document.getElementById('buyaccount').style.display = 'none';
		}else{
			document.getElementById('buyratedisplay').innerHTML = '<b>&#8358;'+(parseFloat(document.getElementById('buyaltrate').value) + addedrate)+'</b>';
			document.getElementById('minbuydisplay').innerHTML = '<b>$'+(document.getElementById('buyaltmin').value)+'</b>';
			document.getElementById('maxbuydisplay').innerHTML = '<b>$'+(document.getElementById('buyaltmax').value)+'</b>';
			document.getElementById('buyaccount').style.display = 'block';
			document.getElementById('buyaccount').setAttribute('placeholder', buycurrency+' Address');
			if(document.getElementById('buycurrencydir').checked){
				document.getElementById('buyamount').setAttribute('placeholder', 'Amount In '+buycurrency);
				document.getElementById('buycurrencydir').value = buycurrency;
			}else{
				document.getElementById('buyamount').setAttribute('placeholder', 'Amount In USD');
				document.getElementById('buycurrencydir').value = 'USD';
			}
		}
		if(buycurrency){
			if(buycur !== 'btc' && giftcardarr.indexOf(buycurrency) === -1){
				buyprealt = localStorage.getItem("buycur");
				if(buycurrency === 'ETH'){				
					document.getElementById('buyeth').innerHTML = '<b>NB: $10 ETH Fee will be deducted from the amount you are buying</b>';
					document.getElementById('buyeth').className = 'incsizespan_error center';
					document.getElementById('buyeth').style.display = 'block';
				}
				if(buyprealt === buycur){
					SkyCalculate('cc', buycur, 'buyamount', 'buysummary');
				}else{
					localStorage.setItem("buycur", buycur);
					setTimeout(function(){ SkyCalculate('cc', buycur, 'buyamount', 'buysummary'); }, 800);	
				}
			}else{
				SkyCalculate('cc', buycur, 'buyamount', 'buysummary');
			}			
		}
	}else if(cryptoarr.indexOf(buycurrency) === -1 && document.getElementById('buycurrencydirswitch')){
		document.getElementById('buyaccountcamera').className = 'camera';
		document.getElementById('buycurrencydirswitch').className = 'hide';
		document.getElementById('buyamount').setAttribute('placeholder', 'Amount In USD');
		document.getElementById('buycurrencydir').value = 'USD';
		document.getElementById('buyaccount').style.display = 'none';
		document.getElementById('buyfeedback').innerHTML = '';
		document.getElementById('buyfeedback').className = 'incsizespan center';
		document.getElementById('buyeth').innerHTML = '';
		document.getElementById('buyeth').className = 'incsizespan center';
		document.getElementById('buyeth').style.display = 'none';
		
		if(buymethod === 'CC'){
			addedrate = parseFloat(document.getElementById('addedrate').value);
		}else{
			addedrate = 0;
		}	
		if(buycurrency){
			if(buycur !== 'pm' && buycur !== 'usdt' && giftcardarr.indexOf(buycurrency) === -1)
			{
				buycur = 'alt';
			}
			else if(giftcardarr.indexOf(buycurrency) !== -1)
			{
				buycur = 'gift';
			}
			document.getElementById('buyaccountname').value = ((document.getElementById('buycurrency').options[document.getElementById('buycurrency').selectedIndex].text).split(' - '))[1];
			document.getElementById('buyamount').setAttribute('placeholder', 'Amount In USD');
			document.getElementById('buyratedisplay').innerHTML = '<b>&#8358;'+(parseFloat(document.getElementById('buy'+buycur+'rate').value) + addedrate)+'</b>';
			document.getElementById('minbuydisplay').innerHTML = '<b>$'+(document.getElementById('buy'+buycur+'min').value)+'</b>';
			document.getElementById('maxbuydisplay').innerHTML = '<b>$'+(document.getElementById('buy'+buycur+'max').value)+'</b>';
			if(buycur === 'pm'){
				document.getElementById('buyaccount').style.display = 'block';
				document.getElementById('buyaccount').setAttribute('placeholder', 'PM Account[U***]');
			}
			if(buycur === 'usdt'){
				document.getElementById('buyaccount').style.display = 'block';
				document.getElementById('buyaccount').setAttribute('placeholder', 'Tether USD [TRC20] Address');
			}
			
			SkyCalculate('cc', buycur, 'buyamount', 'buysummary');
		}else{
			document.getElementById('buysummary').style.display = 'none';
			document.getElementById('buyratedisplay').innerHTML = '';
			document.getElementById('minbuydisplay').innerHTML = '';
			document.getElementById('maxbuydisplay').innerHTML = '';
		}	
	}
	
	if(document.getElementById('buycodewrap') && buymethod === 'EN'){
		document.getElementById('buycodewrap').className = 'container__control--input password fixpost';
	}else if(document.getElementById('buycodewrap')){
		document.getElementById('buycodewrap').className = 'container__control--input password fixpost hide';
	}

	var depositprealt, depositcur = depositcurrency.toLowerCase();
	if(cryptoarr.indexOf(depositcurrency) !== -1 && document.getElementById('depositcurrencydirswitch'))
	{	
		document.getElementById('depositcodewrap').className = 'container__control--input password fixpost hide';
		document.getElementById('depositcurrencydirswitch').className = 'disshow';
		document.getElementById('depositcurrencydirdisplay').innerHTML = depositcurrency;
		document.getElementById('depositaccountname').value = ((document.getElementById('depositcurrency').options[document.getElementById('depositcurrency').selectedIndex].text).split(' - '))[1];
		document.getElementById('depositfeedback').innerHTML = '';
		document.getElementById('depositfeedback').className = 'incsizespan center';
		if(document.getElementById('depositcurrencydir').checked){
			document.getElementById('depositamount').setAttribute('placeholder', 'Amount In '+depositcurrency);
			document.getElementById('depositcurrencydir').value = depositcurrency;
		}else{
			document.getElementById('depositamount').setAttribute('placeholder', 'Amount In USD');
			document.getElementById('depositcurrencydir').value = 'USD';
		}
		if(depositcurrency){
			if(depositcur !== 'btcen' && depositcur !== 'btc' && depositcur !== 'cc' && depositcur !== 'bt'){
				depositprealt = localStorage.getItem("depositcur");
				if(depositprealt === depositcur){
					depositcur = 'alt';
					SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary');
				}else{
					localStorage.setItem("depositcur", depositcur);
					depositcur = 'alt';
					setTimeout(function(){ SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary'); }, 800);	
				}
			}else{
				
				if(depositcur === 'btcen'){
					document.getElementById('depositcodewrap').className = 'container__control--input password fixpost';
				}
				SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary');
			}		
			document.getElementById('depositratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'rate').value)+'</b>';
			document.getElementById('mindepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'min').value)+'</b>';
			document.getElementById('maxdepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'max').value)+'</b>';
			SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary');
		}
	}else if(cryptoarr.indexOf(depositcurrency) === -1 && document.getElementById('depositcurrencydirswitch')){
		document.getElementById('depositcodewrap').className = 'container__control--input password fixpost hide';
		document.getElementById('depositcurrencydirswitch').className = 'hide';
		document.getElementById('depositamount').setAttribute('placeholder', 'Amount In USD');
		document.getElementById('depositcurrencydir').value = 'USD';
		document.getElementById('depositfeedback').innerHTML = '';
		document.getElementById('depositfeedback').className = 'incsizespan center';
		if(depositcurrency){
			
			if(depositcur === 'cc' || depositcur === 'bt'){
				document.getElementById('depositaccountname').value = ((document.getElementById('depositcurrency').options[document.getElementById('depositcurrency').selectedIndex].text).split(' - '))[0];
				document.getElementById('depositamount').setAttribute('placeholder', 'Amount In NGN');
				
				var rate = parseFloat(document.getElementById('deposit'+depositcur+'rate').value);
				var diff = parseFloat(document.getElementById('depositbtadded').value);				
				if(depositcur === 'cc'){
					if(diff > 0){
						rate = rate + diff;
					}
				}
				document.getElementById('depositratedisplay').innerHTML = '<b>&#8358;'+rate+'</b>';
				document.getElementById('mindepositdisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'min').value)+'</b>';
				document.getElementById('maxdepositdisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'max').value)+'</b>';				
			}else if(depositcur === 'pm'){
				document.getElementById('depositaccountname').value = ((document.getElementById('depositcurrency').options[document.getElementById('depositcurrency').selectedIndex].text).split(' - '))[1];
				document.getElementById('depositratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'rate').value)+'</b>';
				document.getElementById('mindepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'min').value)+'</b>';
				document.getElementById('maxdepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'max').value)+'</b>';	
			}else if(depositcur === 'usdt'){
				document.getElementById('depositaccountname').value = ((document.getElementById('depositcurrency').options[document.getElementById('depositcurrency').selectedIndex].text).split(' - '))[1];
				document.getElementById('depositratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'rate').value)+'</b>';
				document.getElementById('mindepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'min').value)+'</b>';
				document.getElementById('maxdepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'max').value)+'</b>';
			}else {
				document.getElementById('depositaccountname').value = ((document.getElementById('depositcurrency').options[document.getElementById('depositcurrency').selectedIndex].text).split(' - '))[1];		
				depositcur = 'alt';
				document.getElementById('depositratedisplay').innerHTML = '<b>&#8358;'+(document.getElementById('deposit'+depositcur+'rate').value)+'</b>';
				document.getElementById('mindepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'min').value)+'</b>';
				document.getElementById('maxdepositdisplay').innerHTML = '<b>$'+(document.getElementById('deposit'+depositcur+'max').value)+'</b>';
			}			
			SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary');
		}else{
			document.getElementById('depositsummary').style.display = 'none';
			document.getElementById('depositratedisplay').innerHTML = '';
			document.getElementById('mindepositdisplay').innerHTML = '';
			document.getElementById('maxdepositdisplay').innerHTML = '';
		}	
	}
			
	//ONSWITCH CHANGE
	const handleSwitchChange = (e) => {
		//e.preventDefault()
		var target, thisid, thiscurid, thistype, thiscur;
        target = e.target;
        thisid = target.id;
		thiscurid = thisid.slice(0, -3);
		thistype = thisid.slice(0, -11);
		thiscur = document.getElementById(thiscurid).value;
        
        if(target.checked){		
			document.getElementById(thistype+'amount').setAttribute('placeholder', 'Amount In '+thiscur);
			document.getElementById(thistype+'currencydir').value = thiscur;
			if(thistype === 'sell'){
				document.getElementById('sellfeedback').innerHTML = '';
				document.getElementById('sellfeedback').className = 'incsizespan center';
				setSellCurrencydir(thiscur);
				SkyCalculate(thiscur.toLowerCase(), 'cc', thistype+'amount', thistype+'summary');
			}else if(thistype === 'buy'){				
				setBuyCurrencydir(thiscur);
				SkyCalculate('cc', thiscur.toLowerCase(), thistype+'amount', thistype+'summary');
			}else if(thistype === 'deposit'){
				setDepositCurrencydir(thiscur);
				SkyCalculate(thiscur.toLowerCase(), 'en', thistype+'amount', thistype+'summary');
			}
        }else{
			document.getElementById(thistype+'amount').setAttribute('placeholder', 'Amount In USD');
			document.getElementById(thistype+'currencydir').value = 'USD';	
			if(thistype === 'sell'){
				document.getElementById('sellfeedback').innerHTML = '';
				document.getElementById('sellfeedback').className = 'incsizespan center';
				setSellCurrencydir('USD');
				SkyCalculate(thiscur.toLowerCase(), 'cc', thistype+'amount', thistype+'summary');
			}else if(thistype === 'buy'){
				setBuyCurrencydir('USD');
				SkyCalculate('cc', thiscur.toLowerCase(), thistype+'amount', thistype+'summary');
			}else if(thistype === 'deposit'){
				setDepositCurrencydir('USD');
				SkyCalculate(thiscur.toLowerCase(), 'en', thistype+'amount', thistype+'summary');
			}
        }       
    }
	
	const handleKeyUp = (e) => {
		//e.preventDefault()
		var target, thisid, thistype, thisv; // thiscurid, thiscur,
        target = e.target;
        thisid = target.id;
		thisv = thisid.substring(0, 3);
		if(thisv === 'sel'){thistype = 'sell';}else if(thisv === 'buy'){thistype = 'buy';}else if(thisv === 'dep'){thistype = 'deposit';}else if(thisv === 'wit'){thistype = 'withdraw';}else if(thisid === 'quicksellbtcamount'){thistype = 'quicksellbtc';}else if(thisid === 'sendbtcamount'){thistype = 'sendbtc';}else if(thisid === 'quicksellusdtamount'){thistype = 'quicksellusdt';}else if(thisid === 'sendusdtamount'){thistype = 'sendusdt';}
		
		if(thistype === 'sell'){
			SkyCalculate(sellcur, 'cc', 'sellamount', 'sellsummary');
		}else if(thistype === 'buy'){
			SkyCalculate('cc', buycur, 'buyamount', 'buysummary');
		}else if(thistype === 'deposit'){
			SkyCalculate(depositcur, 'en', 'depositamount', 'depositsummary');
		}else if(thistype === 'withdraw'){
			SkyCalculate('en', 'bd', 'withdrawamount', 'withdrawsummary');
		}else if(thistype === 'quicksellbtc'){
			SkyCalculate('bt', 'cc', 'quicksellbtcamount', 'quicksellbtcsummary');
		}else if(thistype === 'sendbtc'){
			SkyCalculate('bten', 'bt', 'sendbtcamount', 'sendbtcsummary');
		}else if(thistype === 'quicksellusdt'){
			SkyCalculate('usdt', 'cc', 'quicksellusdtamount', 'quicksellusdtsummary');
		}else if(thistype === 'sendusdt'){
			SkyCalculate('usdten', 'usdt', 'sendusdtamount', 'sendusdtsummary');
		}
	}
	
	const onPhoneSMS = (e) => {
		if(document.getElementById('sellsms').checked){
			document.getElementById('sellsmsphonewrap').className = 'container__control--input';	
		}else{
			document.getElementById('sellsmsphonewrap').className = 'container__control--input hide';
		}
	}
		
	const handlePhoneSMS = (e) => {
		//e.preventDefault()
		var target, thisid, thistype, thisv;
        target = e.target;
        thisid = target.id;
		thisv = thisid.substring(0, 3);
		if(thisv === 'sel'){thistype = 'sell';}else if(thisv === 'buy'){thistype = 'buy';}else if(thisv === 'dep'){thistype = 'deposit';}
		
		if(thistype === 'sell'){
			
		}
	}
	
	const handleFetchBank = (e) => {
		e.preventDefault()
		if(document.getElementById('sellcontinue').checked)
		{
			var a, b, c, acct, bank;
			a = 'sellbankaccount';
			b = 'sellbankname';
			c = 'sellbanksummary';
			acct = document.getElementById(a).value;
			bank = document.getElementById(b).value;
			const mainString = bank.toLowerCase();
			const searchStrings = ["opay", "palm"];
			document.getElementById(a+'name').value = '';
			document.getElementById(c).style.display = 'none';
			document.getElementById(c).className = 'incsizespansms center hide';
			if(acct.length !== 10){		
				if(acct.length === 11 && searchStrings.some(searchString => mainString.includes(searchString))){		
					
				}else{
					return false;
				}
			}else if(!bank){
				return false;
			}
			
			output = {
				acct: a,
				bank: b,
				display: c,
				key: localStorage.getItem('_key')
			}
			fetchBankName(output);	
		}else{
			return false;
		}
	}
	
	const onSubmitSell = (e) => {
		var unit, isnew, isreg, sms, smsphone, amount, cur, altcoin, account, accountname, method, rate, email, sellbankacctconfirm, bankname, bankaccount, bankaccountname, emailcode, msg, currency;
		
		unit = document.getElementById('sellcurrencydir').value;
		isreg = document.getElementById('isreg').value;
		isnew = document.getElementById('isnew').value;
		amount = document.getElementById('sellamount').value;
		currency = document.getElementById('sellcurrency').value;
		email = document.getElementById('loggedemail').value;
		sellbankacctconfirm = document.getElementById('sellreg').value;
		accountname = document.getElementById('sellaccountname').value;
		altcoin = '0';
		account = '';
		method = '';
		cur = sellcurrency.toLowerCase();
		document.getElementById('sellfeedback').innerHTML = '';
		document.getElementById('sellfeedback').className = 'incsizespan center';
		
		
		if(document.getElementById('sellsms').checked){
			sms = '1';
			smsphone = document.getElementById('sellsmsphone').value;
		}else{
			sms = '0';
		}
		
		if(document.getElementById('sellcontinue') && document.getElementById('sellcontinue').checked){
			bankaccount = document.getElementById('sellbankaccount').value;
			bankname = document.getElementById('sellbankname').value;
			bankaccountname = document.getElementById('sellbankaccountname').value;
		}		
		
		if(cryptoaltarr.indexOf(sellcurrency) !== -1){
			cur = 'alt';
			altcoin = '1';
		}		
		
		if(!sellcurrency){
			msg = 'Please select a currency to sell';
			document.getElementById('sellfeedback').innerHTML = msg;
			document.getElementById('sellfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!amount)
		{
			msg = 'Please enter amount to sell';
			document.getElementById('sellfeedback').innerHTML = msg;
			document.getElementById('sellfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(sellbankacctconfirm === '0')
		{
			if(document.getElementById('sellcontinue') && document.getElementById('sellcontinue').checked){
				bankaccount = document.getElementById('sellbankaccount').value;
				bankname = document.getElementById('sellbankname').value;
				bankaccountname = document.getElementById('sellbankaccountname').value;
				if(!bankaccount){
					msg = 'Please enter bank account number';
					document.getElementById('sellfeedback').innerHTML = msg;
					document.getElementById('sellfeedback').className = 'incsizespan_error center';
					return false;
				}else if(!bankname){
					msg = 'Please select bank name';
					document.getElementById('sellfeedback').innerHTML = msg;
					document.getElementById('sellfeedback').className = 'incsizespan_error center';
					return false;
				}else{
					msg = 'Enter a valid account details';
					document.getElementById('sellfeedback').innerHTML = msg;
					document.getElementById('sellfeedback').className = 'incsizespan_error center';
					return false;
				}
			}else{
				if(document.getElementById('sellcontinue')){
					msg = 'Please check box to continue';
					document.getElementById('sellfeedback').innerHTML = msg;
					document.getElementById('sellfeedback').className = 'incsizespan_error center';
					return false;
				}else{
					document.getElementById('sellreg').value = '1';
				}
			}
		}
		if(isnew === '1'){
			emailcode = document.getElementById('sellemailcode').value;
			if(emailcode.length !== 5){
				msg = 'Please enter email code';
				document.getElementById('sellfeedback').innerHTML = msg;
				document.getElementById('sellfeedback').className = 'incsizespan_error center';
				return false;
			}else if(emailcode !== localStorage.getItem("appsellexcode")){
				msg = 'Please enter a valid email code';
				document.getElementById('sellfeedback').innerHTML = msg;
				document.getElementById('sellfeedback').className = 'incsizespan_error center';
				return false;
			}
		}

		if(sellcurrency !== currency){
			msg = 'Please select currency to sell';
			document.getElementById('sellfeedback').innerHTML = msg;
			document.getElementById('sellfeedback').className = 'incsizespan_error center';
			return false;
		}
		
		rate = document.getElementById('sell'+cur+'rate').value;
		
		if(isreg === '0' && sms === '1'){		
			output = {
				'amount': amount,
				'account': account,
				'accountname': accountname,
				'alt': altcoin,
				'bank': bankname,	
				'bankname': bankaccountname,
				'banknumber': bankaccount,
				'currency': currency,
				'direction': 'sell',
				'email': email,
				'isnew': isnew,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'smsno': smsphone,
				'unit': unit,
				'key': localStorage.getItem('_key')
			};
		}else if(isreg === '0' && sms === '0'){		
			output = {
				'amount': amount,
				'account': account,
				'accountname': accountname,
				'alt': altcoin,
				'bank': bankname,	
				'bankname': bankaccountname,
				'banknumber': bankaccount,
				'currency': currency,
				'direction': 'sell',
				'email': email,
				'isnew': isnew,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'unit': unit,
				'key': localStorage.getItem('_key')
			};
		}else{
			output = {
				'amount': amount,
				'account': account,
				'accountname': accountname,
				'alt': altcoin,
				'currency': currency,
				'direction': 'sell',
				'email': email,
				'isnew': isnew,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'unit': unit,
				'key': localStorage.getItem('_key')
			};
		}
		onPostSell(output);
	}
	
	const onSubmitBuy = (e) => {
		
		var unit, isreg, sms, amount, cur, altcoin, account, accountname, method, rate, email, acctconfirm, msg, currency, giftcard, buycode;
		
		unit = document.getElementById('buycurrencydir').value;
		isreg = document.getElementById('isreg').value;
		amount = document.getElementById('buyamount').value;
		currency = document.getElementById('buycurrency').value;
		email = document.getElementById('loggedemail').value;		
		acctconfirm = document.getElementById('buyreg').value;	
		accountname = document.getElementById('buyaccountname').value;	
		altcoin = '0';
		giftcard = '0';
		account = document.getElementById('buyaccount').value;
		method = document.getElementById('buymethod').value;
		cur = buycurrency.toLowerCase();
			
		if(document.getElementById('buysms').checked){
			sms = '1';
		}else{
			sms = '0';
		}		
		
		
		if(cryptoaltarr.indexOf(buycurrency) !== -1){
			cur = 'alt';
			altcoin = '1';
		}

		if(giftcardarr.indexOf(buycurrency) !== -1){
			cur = 'gift';
			giftcard = '1';
		}
		
		if(!document.getElementById('buycodewrap').classList.contains('hide')){
			buycode = document.getElementById('buycode').value;
			
			if(!buycode){
				msg = 'Confirmation code is required';
				document.getElementById('buyfeedback').innerHTML = msg;
				document.getElementById('buyfeedback').className = 'incsizespan_info center';
				return false;
			}
		}
		
		if(!buycurrency){
			msg = 'Please select a currency to buy';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!method)
		{
			msg = 'Please select a payment method';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!amount)
		{
			msg = 'Please enter amount to buy';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!account && giftcardarr.indexOf(buycurrency) === -1)
		{
			msg = 'Please enter your '+buycurrency+' account';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(acctconfirm === '0')
		{
			
		}
		var confirmacct = '0';
		if(document.getElementById('buyacctconfirm') && !document.getElementById('buyacctconfirm').checked){
			msg = 'Check Box if PM Account is Correct';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}else if(document.getElementById('buyacctconfirm') && document.getElementById('buyacctconfirm').checked){			
			confirmacct = '1';			
		}
		
		if(buycurrency !== currency){
			msg = 'Please select currency to buy';
			document.getElementById('buyfeedback').innerHTML = msg;
			document.getElementById('buyfeedback').className = 'incsizespan_error center';
			return false;
		}
		
		
		
		
		rate = document.getElementById('buy'+cur+'rate').value;
		
		if(!document.getElementById('buycodewrap').classList.contains('hide')){
		
			if(giftcardarr.indexOf(buycurrency) === -1 && confirmacct === '1'){
				output = {
					'amount': amount,
					'account': account,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'confirm': '1',
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'ccode': buycode,
					'key': localStorage.getItem('_key')
				};
			}else if(giftcardarr.indexOf(buycurrency) === -1){
				output = {
					'amount': amount,
					'account': account,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'ccode': buycode,
					'key': localStorage.getItem('_key')
				};
			}else{
				output = {
					'amount': amount,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'ccode': buycode,
					'key': localStorage.getItem('_key')
				};
			}
			
		}
		else
		{
			if(giftcardarr.indexOf(buycurrency) === -1 && confirmacct === '1'){
				output = {
					'amount': amount,
					'account': account,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'confirm': '1',
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'key': localStorage.getItem('_key')
				};
			}else if(giftcardarr.indexOf(buycurrency) === -1){
				output = {
					'amount': amount,
					'account': account,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'key': localStorage.getItem('_key')
				};
			}else{
				output = {
					'amount': amount,
					'accountname': accountname,
					'alt': altcoin,
					'gift': giftcard,
					'currency': currency,
					'direction': 'buy',
					'email': email,
					'isreg': isreg,
					'method': method,
					'rate': rate,
					'rtype': 'trade',
					'sms': sms,
					'unit': unit,
					'key': localStorage.getItem('_key')
				};
			}
		
		}
		onPostBuy(output);
	}
	
	const onSubmitDeposit = (e) => {
		var unit, isreg, sms, amount, cur, altcoin, account, accountname, method, rate, email, msg, currency, depositcode;
		
		unit = document.getElementById('depositcurrencydir').value;
		isreg = document.getElementById('isreg').value;
		amount = document.getElementById('depositamount').value;
		currency = document.getElementById('depositcurrency').value;
		email = document.getElementById('loggedemail').value;
		accountname = document.getElementById('depositaccountname').value;
		altcoin = '0';
		account = '';
		method = document.getElementById('depositcurrency').value;
		cur = depositcurrency.toLowerCase();
		document.getElementById('depositfeedback').innerHTML = '';
		document.getElementById('depositfeedback').className = 'incsizespan center';
			
		if(document.getElementById('depositsms').checked){
			sms = '1';
		}else{
			sms = '0';
		}
		
		if(!document.getElementById('depositcodewrap').classList.contains('hide')){
			depositcode = document.getElementById('depositcode').value;
			
			if(!depositcode){
				msg = 'Confirmation code is required';
				document.getElementById('depositfeedback').innerHTML = msg;
				document.getElementById('depositfeedback').className = 'incsizespan_info center';
				return false;
			}
		}		
		
		
		if(cryptoaltarr.indexOf(depositcurrency) !== -1){
			cur = 'alt';
			altcoin = '1';
		}		
		
		if(!depositcurrency){
			msg = 'Please select a currency to deposit';
			document.getElementById('depositfeedback').innerHTML = msg;
			document.getElementById('depositfeedback').className = 'incsizespan_error center';
			return false;
		}
		else if(!amount)
		{
			msg = 'Please enter amount to deposit';
			document.getElementById('depositfeedback').innerHTML = msg;
			document.getElementById('depositfeedback').className = 'incsizespan_error center';
			return false;
		}

		if(depositcurrency !== currency){
			msg = 'Please select currency to deposit';
			document.getElementById('depositfeedback').innerHTML = msg;
			document.getElementById('depositfeedback').className = 'incsizespan_error center';
			return false;
		}
		
		rate = document.getElementById('deposit'+cur+'rate').value;
		
		
		if(!document.getElementById('depositcodewrap').classList.contains('hide'))
		{
			output = {
				'amount': amount,
				'accountname': accountname,
				'alt': altcoin,
				'currency': currency,
				'direction': 'deposit',
				'email': email,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'unit': unit,
				'ccode': depositcode,
				'key': localStorage.getItem('_key')
			};
		}
		else if(giftcardarr.indexOf(depositcurrency) === -1)
		{
			output = {
				'amount': amount,
				'accountname': accountname,
				'alt': altcoin,
				'currency': currency,
				'direction': 'deposit',
				'email': email,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'unit': unit,
				'key': localStorage.getItem('_key')
			};
		}
		else
		{
			output = {
				'amount': amount,
				'account': account,
				'accountname': accountname,
				'alt': altcoin,
				'currency': currency,
				'direction': 'deposit',
				'email': email,
				'isreg': isreg,
				'method': method,
				'rate': rate,
				'rtype': 'trade',
				'sms': sms,
				'unit': unit,
				'key': localStorage.getItem('_key')
			};
		}
		onPostDeposit(output);
	}
	
	const onSubmitQuickSellBTC = (e) => {
		var amount, code, msg, email;		
		amount = document.getElementById('quicksellbtcamount').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('quicksellbtcconfirmationcode').value;
		document.getElementById('quicksellbtcfeedback').innerHTML = '';
		document.getElementById('quicksellbtcfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to sell';
			document.getElementById('quicksellbtcfeedback').innerHTML = msg;
			document.getElementById('quicksellbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('quicksellbtcfeedback').innerHTML = msg;
			document.getElementById('quicksellbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amountusd': amount,
			'ccode': code,
			'email': email,
			'rtype': 'quicksellbtc',
			'key': localStorage.getItem('_key')
		};
		onPostQuickSellBTC(output);
	}
	
	const onSubmitQuickSellUSDT = (e) => {
		var amount, code, msg, email;		
		amount = document.getElementById('quicksellusdtamount').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('quicksellusdtconfirmationcode').value;
		document.getElementById('quicksellusdtfeedback').innerHTML = '';
		document.getElementById('quicksellusdtfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to sell';
			document.getElementById('quicksellusdtfeedback').innerHTML = msg;
			document.getElementById('quicksellusdtfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('quicksellusdtfeedback').innerHTML = msg;
			document.getElementById('quicksellusdtfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amountusd': amount,
			'ccode': code,
			'email': email,
			'rtype': 'quicksellusdt',
			'key': localStorage.getItem('_key')
		};
		onPostQuickSellUSDT(output);
	}
	
	
	const onSubmitQuickSellALT = (e) => {
		var target, thisid;
        target = e.target;
        thisid = target.id;
		console.log(thisid);
		
		var amount, code, msg, email;		
		amount = document.getElementById('quicksellbtcamount').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('quicksellbtcconfirmationcode').value;
		document.getElementById('quicksellbtcfeedback').innerHTML = '';
		document.getElementById('quicksellbtcfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to sell';
			document.getElementById('quicksellbtcfeedback').innerHTML = msg;
			document.getElementById('quicksellbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('quicksellbtcfeedback').innerHTML = msg;
			document.getElementById('quicksellbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amountusd': amount,
			'ccode': code,
			'email': email,
			'rtype': 'quicksellbtc',
			'key': localStorage.getItem('_key')
		};
		onPostQuickSellALT(output);
	}
		
	const onSubmitWithdraw = (e) => {
		var amount, code, msg, email;		
		amount = document.getElementById('withdrawamount').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('withdrawconfirmationcode').value;
		document.getElementById('withdrawfeedback').innerHTML = '';
		document.getElementById('withdrawfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to withdraw';
			document.getElementById('withdrawfeedback').innerHTML = msg;
			document.getElementById('withdrawfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('withdrawfeedback').innerHTML = msg;
			document.getElementById('withdrawfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amount': amount,
			'ccode': code,
			'email': email,
			'rtype': 'withdraw',
			'direction': 'withdraw',
			'key': localStorage.getItem('_key')
		};
		onPostWithdraw(output);
	}
	
	const onSubmitSendBTC = (e) => {
		var account, amount, unit, code, msg, email;		
		amount = document.getElementById('sendbtcamount').value;
		unit = document.getElementById('sendbtcdir').value;
		account = document.getElementById('sendbtcaddress').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('sendbtcconfirmationcode').value;
		document.getElementById('sendbtcfeedback').innerHTML = '';
		document.getElementById('sendbtcfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to send';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!account)
		{
			msg = 'Please enter bitcoin address';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amount': amount,
			'unit': unit,
			'account': account,
			'ccode': code,
			'email': email,
			'rtype': 'sendbtc',
			'direction': 'sendbtc',
			'key': localStorage.getItem('_key')
		};
		onPostSendBTC(output);
	}
		
	const onSubmitSendUSDT = (e) => {
		var account, amount, unit, code, msg, email;		
		amount = document.getElementById('sendusdtamount').value;
		unit = document.getElementById('sendusdtdir').value;
		account = document.getElementById('sendusdtaddress').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('sendusdtconfirmationcode').value;
		document.getElementById('sendusdtfeedback').innerHTML = '';
		document.getElementById('sendusdtfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to send';
			document.getElementById('sendusdtfeedback').innerHTML = msg;
			document.getElementById('sendusdtfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!account)
		{
			msg = 'Please enter trc20 usdt address';
			document.getElementById('sendusdtfeedback').innerHTML = msg;
			document.getElementById('sendusdtfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('sendusdtfeedback').innerHTML = msg;
			document.getElementById('sendusdtfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amount': amount,
			'unit': unit,
			'account': account,
			'ccode': code,
			'email': email,
			'rtype': 'sendusdt',
			'direction': 'sendusdt',
			'key': localStorage.getItem('_key')
		};
		
		onPostSendUSDT(output);
	}
	
	const onSubmitSendALT = (e) => {
		
		var target, thisid;
        target = e.target;
        thisid = target.id;
		//console.log(thisid);
		
		var account, amount, unit, code, msg, email;		
		amount = document.getElementById('sendbtcamount').value;
		unit = document.getElementById('sendbtcdir').value;
		account = document.getElementById('sendbtcaddress').value;
		email = document.getElementById('loggedemail').value;
		code = document.getElementById('sendbtcconfirmationcode').value;
		document.getElementById('sendbtcfeedback').innerHTML = '';
		document.getElementById('sendbtcfeedback').className = 'incsizespan center';		
		if(!amount)
		{
			msg = 'Please enter amount to send';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!account)
		{
			msg = 'Please enter altcoin address';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
		if(!code)
		{
			msg = 'Please enter confirmation code';
			document.getElementById('sendbtcfeedback').innerHTML = msg;
			document.getElementById('sendbtcfeedback').className = 'incsizespan_error center';
			return false;
		}
			
		output = {
			'amount': amount,
			'unit': unit,
			'account': account,
			'ccode': code,
			'email': email,
			'rtype': 'sendbtc',
			'direction': 'sendbtc',
			'key': localStorage.getItem('_key')
		};
		onPostSendALT(output);
	}
	
	function isNumeric(str) 
	{
		return !isNaN(str - parseFloat(str));
	}
	
	function Round(a,v)
	{
		v = parseFloat(v);
		return v.toFixed(a);
	}
	
	function Rounder(v) 
	{
		return v.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	
	function validateEmail(str) 
	{
		var lastAtPos = str.lastIndexOf('@');
		var lastDotPos = str.lastIndexOf('.');
		return (lastAtPos < lastDotPos && lastAtPos > 0 && str.indexOf('@@') === -1 && lastDotPos > 2 && (str.length - lastDotPos) > 2);
	}
	
	function SkyCalculate(fro, to, amount, display)
	{
		var selectunit;
		var type = amount.slice(0, -6).toLowerCase();	
		
		if(document.getElementById(type+'currencydir')){
			selectunit = document.getElementById(type+'currencydir').value;
		}else{
			selectunit = document.getElementById(type+'dir').value;
		}
		
		var selectcurr, selectcur, selectmtd, selectamount, summarydisplay, ccfee, bdfee, rate, addedrate, usdamount, ngnamount, btcamount, altamount, usdalt, ngnamountfee, pmbalance, usdbtc, convrate, diff, limit, ongnamount, totwithdrawal, withfee, preto;
	
		
		if(type === 'buy'){
			selectcurr = document.getElementById(type+'currency').value;
			selectcur = selectcurr.toLowerCase();
			selectmtd = (document.getElementById(type+'method').value).toLowerCase();
			selectamount = document.getElementById(type+'amount').value;
			usdamount = parseFloat(document.getElementById(amount).value);
			ccfee = 0;
			bdfee = 0;
			summarydisplay = '';
			
			
			if(selectamount === '' || selectcur === '' || selectmtd === ''){				
				document.getElementById(display).style.display = 'none';
				return false;
			}		
			
			if(giftcardarr.indexOf(selectcurr) !== -1)
			{
				to = 'gift';
			}
			
			if(cryptoaltarr.indexOf(selectcurr) !== -1)
			{
				preto = to;
				to = 'alt';
			}
			
			rate = parseFloat(document.getElementById(type+to+'rate').value);
			
			if(selectmtd === 'cc'){
				addedrate = parseFloat(document.getElementById('addedrate').value);
				if(addedrate > 0){
					rate = rate + addedrate;
				}				
				ccfee = parseFloat(document.getElementById(type+'fee').value);
			}
			if(selectmtd === 'bt'){
				bdfee = parseFloat(document.getElementById(type+'bankfee').value);
			}
			
			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectmtd !== '' && selectunit === 'USD')
			{		
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('buyamt').value = ngnamount;
				ngnamount = Rounder(ngnamount); 
			
				if(selectcur === 'btc'){
					usdbtc = parseFloat(document.getElementById('usdbtc').value);
					btcamount = usdamount * usdbtc;
					btcamount = Round(8,btcamount);
					if(isNaN(btcamount)){
						summarydisplay += '<b>Please reselect currency</b><br/>';
					}else{
						summarydisplay += '<b>~ '+btcamount+' '+selectcur.toUpperCase()+'</b><br/>';
					}				
				}else if(selectcur !== 'pm' && selectcur !== 'usdt' && giftcardarr.indexOf(selectcurr) === -1){
					usdalt = parseFloat(document.getElementById('usd'+preto).value);
					altamount = usdamount * usdalt;
					altamount = Round(8,altamount);				
					if(isNaN(altamount)){
						summarydisplay += '<b>Please reselect currency</b><br/>';
					}else{
						summarydisplay += '<b>~ '+altamount+' '+selectcur.toUpperCase()+'</b><br/>';
					}	
				}
				
				summarydisplay += 'Payment Due <b>&#8358;'+ngnamount+'</b>';
				
				ngnamountfee = usdamount * rate;			
				if(ccfee > 0){
					summarydisplay += '<br/>Gateway Fee <b>&#8358;'+ccfee+'</b>';
					ngnamountfee = ngnamountfee + ccfee;
				}
				if(bdfee > 0){
					summarydisplay += '<br/>Bank Fee <b>&#8358;'+bdfee+'</b>';
					ngnamountfee = ngnamountfee + bdfee;
				}
				
				ngnamountfee = Round(2,ngnamountfee);
				ngnamountfee = Rounder(ngnamountfee);
				summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
				
				if(selectcur === 'pm'){
					lookUp('buyaccount', 'pm');
				}else{
					document.getElementById('buyaccountsummary').style.display = 'none';
				}
			}
			else if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectmtd !== '' && selectunit !== 'USD')
			{
				if(selectcur === 'btc'){
					btcamount = usdamount;
					usdbtc = parseFloat(document.getElementById('usdbtc').value);
					usdamount = btcamount / usdbtc;
					usdamount = Round(2,usdamount);
					if(isNaN(usdamount)){
						summarydisplay += '<b>Please reselect currency</b><br/>';
					}else{
						summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
					}				
				}else if(selectcur !== 'pm' && giftcardarr.indexOf(selectcurr) === -1){
					altamount = usdamount;
					usdalt = parseFloat(document.getElementById('usd'+preto).value);
					usdamount = altamount / usdalt;
					usdamount = Round(2,usdamount);		
					if(isNaN(usdamount)){
						summarydisplay += '<b>Please reselect currency</b><br/>';
					}else{
						summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
					}	
				}
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('buyamt').value = ngnamount;
				ngnamount = Rounder(ngnamount); 
				
				summarydisplay += 'Payment Due <b>&#8358;'+ngnamount+'</b>';				
				ngnamountfee = usdamount * rate;			
				if(ccfee > 0){
					summarydisplay += '<br/>Gateway Fee <b>&#8358;'+ccfee+'</b>';
					ngnamountfee = ngnamountfee + ccfee;
				}
				if(bdfee > 0){
					summarydisplay += '<br/>Bank Fee <b>&#8358;'+bdfee+'</b>';
					ngnamountfee = ngnamountfee + bdfee;
				}
				
				ngnamountfee = Round(2,ngnamountfee);
				ngnamountfee = Rounder(ngnamountfee);
				summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;				
				document.getElementById(display).style.display = 'block';
				if(selectcur === 'pm'){
					lookUp('buyaccount', 'pm');
				}else{
					document.getElementById('buyaccountsummary').style.display = 'none';
				}
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type === 'sell'){
			selectcur = (document.getElementById(type+'currency').value).toLowerCase();
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';
			
			if(fro !== 'pm' && fro !== 'btc' && fro !== 'usdt'){
				fro = 'alt';
			}
			
			rate = parseFloat(document.getElementById(type+fro+'rate').value);

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
		
				if(selectcur === 'btc'){
					usdbtc = parseFloat(document.getElementById('usdbtc').value);
					btcamount = usdamount * usdbtc;
					btcamount = Round(8,btcamount);
				}
				else if(selectcur === 'usdt')
				{
					usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
					btcamount = usdamount * usdbtc;
					btcamount = Round(2,btcamount);
				}
				else if(selectcur !== 'btc' && selectcur !== 'pm')
				{
					usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
					btcamount = usdamount * usdbtc;
					btcamount = Round(8,btcamount);
				}		
					
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('sellamt').value = ngnamount;
				ngnamount = Rounder(ngnamount);			
				
				
				if(selectcur === 'pm'){
					pmbalance = parseFloat(usdamount + (usdamount * 0.0199)).toFixed(2);
					summarydisplay += '<b>$'+Rounder(pmbalance)+'</b> PM Balance is Required<br/>';								
				}else if(selectcur === 'usdt'){
					summarydisplay += '';
					//summarydisplay += '<b>$'+btcamount+'</b><br/>';
					if(isNaN(btcamount)){
						document.getElementById(display).innerHTML = "";
						document.getElementById(display).style.display = 'none';
						return false;
					}
				}else{
					summarydisplay += '<b>~ '+btcamount+' '+selectcur.toUpperCase()+'</b><br/>';
					if(isNaN(btcamount)){
						document.getElementById(display).innerHTML = "";
						document.getElementById(display).style.display = 'none';
						return false;
					}
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit !== 'USD')
			{	
				if(selectcur === 'btc'){
					usdbtc = parseFloat(document.getElementById('usdbtc').value);
					btcamount = usdamount;
					usdamount = btcamount / usdbtc;
					usdamount = Round(2,usdamount);
				}
				else if(selectcur === 'usdt')
				{
					usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
					btcamount = usdamount;
					usdamount = btcamount / usdbtc;
					usdamount = Round(2,usdamount);
				}
				else if(selectcur !== 'btc' && selectcur !== 'pm')
				{
					usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
					btcamount = usdamount;
					usdamount = btcamount / usdbtc;
					usdamount = Round(2,usdamount);
				}
				
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('sellamt').value = ngnamount;
				ngnamount = Rounder(ngnamount); 
				
				if(selectcur === 'pm'){
					pmbalance = parseFloat(usdamount + (usdamount * 0.0199)).toFixed(2);
					summarydisplay += '<b>$'+Rounder(pmbalance)+'</b> PM Balance is Required<br/>';								
				}else if(selectcur === 'usdt'){
					summarydisplay += '<b>$ '+usdamount+'</b><br/>';
					if(isNaN(btcamount)){
						document.getElementById(display).innerHTML = "";
						document.getElementById(display).style.display = 'none';
						return false;
					}
				}else{
					summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
					if(isNaN(usdamount)){
						document.getElementById(display).innerHTML = "";
						document.getElementById(display).style.display = 'none';
						return false;
					}
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type === 'deposit'){
			selectcur = (document.getElementById(type+'currency').value).toLowerCase();
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';
			ccfee = 0;
			bdfee = 0;
			
			if(fro !== 'pm' && fro !== 'btc' && fro !== 'btcen' && fro !== 'cc' && fro !== 'bt' && fro !== 'usdt' && fro !== 'usdten'){
				fro = 'alt';
			}
			
			
			rate = parseFloat(document.getElementById(type+fro+'rate').value);			

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('depositamt').value = ngnamount;
				ngnamount = Rounder(ngnamount);
				
				if(fro === 'pm'){
					pmbalance = parseFloat(usdamount + (usdamount * 0.0199)).toFixed(2);
					summarydisplay += '<b>$'+pmbalance+'</b> PM Balance is Required<br/>';
				}else if(fro === 'btc'){
					convrate = parseFloat(document.getElementById('btenbtrate').value);
					btcamount = (usdamount * convrate);
					btcamount = Round(8,btcamount);
					if(isNaN(btcamount)){
						return false;
					}
					summarydisplay += '<b>~ '+btcamount+' BTC</b><br/>';
				}else if(fro === 'btcen'){
					convrate = parseFloat(document.getElementById('btenbtrate').value);
					btcamount = (usdamount * convrate);
					btcamount = Round(8,btcamount);
					if(isNaN(btcamount)){
						return false;
					}
					
					summarydisplay += '<b>~ '+btcamount+' BTC</b><br/><span id="depositnetwork"></span>';
				}else if(fro === 'usdt'){
					convrate = parseFloat(document.getElementById('usdtenusdtrate').value);
					btcamount = (usdamount * convrate);
					btcamount = Round(2,btcamount);
					if(isNaN(btcamount)){
						return false;
					}
					summarydisplay += '';
					//summarydisplay += '<b>$'+btcamount+'</b><br/>';
				}else if(fro === 'cc'){
					ccfee = parseFloat(document.getElementById(type+'fee').value);
					if(ccfee > 0){
						summarydisplay += 'Gateway Fee <b>&#8358;'+ccfee+'</b><br/>';
					}			
				}else if(fro === 'bt'){
					
				}else if(fro !== ''){
					convrate = parseFloat(document.getElementById('usd'+selectcur).value);
					btcamount = (usdamount * convrate);
					btcamount = Round(8,btcamount);
					if(isNaN(btcamount)){						
						return false;
					}
					summarydisplay += '<b>~ '+btcamount+' '+selectcur.toUpperCase()+'</b><br/>';
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				diff = parseFloat(document.getElementById('depositbtadded').value);
				
				if(fro === 'cc'){
					if(diff > 0){
						//console.log(rate+' '+diff);
						rate = rate + diff;
						//console.log(rate+' '+diff);
					}
					ngnamountfee = (usdamount * rate) + ccfee;
					ngnamountfee = Round(2,ngnamountfee);
					document.getElementById('depositamt').value = ngnamountfee;
					ngnamountfee = Rounder(ngnamountfee);
					summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				}
				if(fro === 'bt'){
					bdfee = parseFloat(document.getElementById(type+'bankfee').value);
					if(bdfee > 0){
						summarydisplay += '<br/>Bank Fee <b>&#8358;'+bdfee+'</b>';
					}
					ngnamountfee = (usdamount * rate) + bdfee;
					ngnamountfee = Round(2,ngnamountfee);
					ngnamountfee = Rounder(ngnamountfee);
					summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				}
				
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
				
				if(fro === 'btcen'){
					//NetworkFee('deposit');
				}
			}
			else if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit !== 'USD')
			{				
				if(fro === 'pm'){
					pmbalance = parseFloat(usdamount + (usdamount * 0.0199)).toFixed(2);
					summarydisplay += '<b>$'+pmbalance+'</b> PM Balance is Required<br/>';
				}else if(fro === 'btc'){
					btcamount = usdamount;
					convrate = parseFloat(document.getElementById('btenbtrate').value);
					usdamount = (btcamount / convrate);
					usdamount = Round(2,usdamount);
					if(isNaN(usdamount)){
						return false;
					}
					summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
				}else if(fro === 'btcen'){
					btcamount = usdamount;
					convrate = parseFloat(document.getElementById('btenbtrate').value);
					usdamount = (btcamount / convrate);
					usdamount = Round(2,usdamount);
					if(isNaN(usdamount)){
						return false;
					}
					summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/><span id="depositnetwork"></span>';
				}else if(fro === 'cc'){
					ccfee = parseFloat(document.getElementById(type+'fee').value);
					if(ccfee > 0){
						summarydisplay += 'Gateway Fee <b>&#8358;'+ccfee+'</b><br/>';
					}			
				}else if(fro === 'bt'){
					
				}else if(fro !== ''){
					btcamount = usdamount;
					convrate = parseFloat(document.getElementById('usd'+selectcur).value);
					usdamount = (btcamount / convrate);
					usdamount = Round(2,usdamount);
					if(isNaN(usdamount)){
						return false;
					}
					summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/><span id="depositnetwork"></span>';				
				}
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('depositamt').value = ngnamount;
				ngnamount = Rounder(ngnamount);
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				diff = parseFloat(document.getElementById('depositbtadded').value);
				
				if(isNaN(usdamount)){
					return false;
				}
				
				
				if(fro === 'cc'){
					if(diff > 0){
						rate = rate + diff;
					}
					ngnamountfee = (usdamount * rate) + ccfee;
					ngnamountfee = Round(2,ngnamountfee);
					document.getElementById('depositamt').value = ngnamountfee;
					ngnamountfee = Rounder(ngnamountfee);
					summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				}
				if(fro === 'bt'){
					bdfee = parseFloat(document.getElementById(type+'bankfee').value);
					if(bdfee > 0){
						summarydisplay += '<br/>Bank Fee <b>&#8358;'+bdfee+'</b>';
					}
					
					ngnamountfee = (usdamount * rate) + bdfee;
					ngnamountfee = Round(2,ngnamountfee);
					ngnamountfee = Rounder(ngnamountfee);
					summarydisplay += '<br/>Pay Total <b>&#8358;'+ngnamountfee+'</b>';
				}
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
				
				if(fro === 'btcen'){
					//NetworkFee('deposit');
				}
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type === 'sendbtc'){
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';
			ccfee = 0;
			
			rate = parseFloat(document.getElementById(fro+to+'rate').value);
			if(usdamount !== '' && selectunit === 'USD'){
				ngnamount = (usdamount * rate);
				ngnamount = Round(8,ngnamount);
				document.getElementById('sendbtcamt').value = ngnamount;
				summarydisplay += '<b>~ '+ngnamount+' BTC</b><br/><span id="sendbtcnetwork"></span>';			
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
				//NetworkFee('sendbtc');
			}else if(usdamount !== '' && selectunit !== 'USD'){
				btcamount = usdamount;
				usdamount = (btcamount / rate);
				usdamount = Round(2,usdamount);
				usdamount = Rounder(usdamount);
				
				summarydisplay += '<b>~ $'+usdamount+'</b><br/><span id="sendbtcnetwork"></span>';			
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
				//NetworkFee('sendbtc');
			}else{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type === 'withdraw'){
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';
			ccfee = 0;
			
			rate = parseFloat(document.getElementById(fro+to+'rate').value);
			limit = parseFloat(document.getElementById(type+'limitfee').value);
			if(usdamount !== '' && !isNaN(usdamount))
			{
				ngnamount = (usdamount * rate);	
				ongnamount = ngnamount;	
				ngnamount = Round(2,ngnamount);
				document.getElementById('withdrawamt').value = ngnamount;	
				ngnamount = Rounder(ngnamount); 
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b><br/>';
				
				if(ongnamount < limit){
					ccfee = parseFloat(document.getElementById(type+'fee').value);
					if(ccfee > 0){
						totwithdrawal = ongnamount + ccfee;
						totwithdrawal = Round(2, totwithdrawal);
						document.getElementById('withdrawamt').value = totwithdrawal;	
						withfee = Round(2, ccfee);				
						withfee = Rounder(withfee); 
						summarydisplay += 'Withdrawal Fee <b>&#8358;'+withfee+'</b><br/>';
					}
				}		
				
				if(!dashboardparams.bankacct){
					document.getElementById('withdrawemailsummary').innerHTML = '<a href="settings">Add Bank Details</a>';
				}
				
				document.getElementById(display).className = 'incsizespansms center';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}else{
				console.log('empty');
				document.getElementById(display).className = 'incsizespan center';
				document.getElementById(display).style.display = 'none';
			}
		}
				
		if(type.slice(0, -3) === 'quicksell'){		
			selectcur = type.replace('quicksell', '');
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';		
			
			if(selectcur !== 'btc'){
				selectcur = 'alt';
			}
			
			rate = parseFloat(document.getElementById('sell'+selectcur+'rate').value);
			selectunit = document.getElementById(type+'dir').value;

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				btcamount = usdamount * usdbtc;
				btcamount = Round(8,btcamount);	
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('quicksellbtcamt').value = ngnamount;
				ngnamount = Rounder(ngnamount);
				
				summarydisplay += '<b>~ '+btcamount+' '+selectcur.toUpperCase()+'</b><br/>';
				if(isNaN(btcamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit !== 'USD')
			{					
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				btcamount = usdamount;
				usdamount = btcamount / usdbtc;
				usdamount = Round(2,usdamount);
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('quicksellbtcamt').value = ngnamount;
				ngnamount = Rounder(ngnamount); 
				
				summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
				if(isNaN(usdamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type.slice(0, -3) === 'send'){
			selectcur = type.replace('send', '');
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';
			if(selectcur !== 'btc'){
				selectcur = 'alt';
			}
			
			selectunit = document.getElementById(type+'dir').value;

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				btcamount = usdamount * usdbtc;
				btcamount = Round(8,btcamount);	
				
				summarydisplay += '<b>~ '+btcamount+' '+selectcur.toUpperCase()+'</b><br/>';
				if(isNaN(btcamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit !== 'USD')
			{					
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				btcamount = usdamount;
				usdamount = btcamount / usdbtc;
				usdamount = Round(2,usdamount);
				
				summarydisplay += '<b>~ $'+Rounder(usdamount)+'</b><br/>';
				if(isNaN(usdamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
				
		if(type.slice(0, -3) === 'quicksellu'){		
			selectcur = type.replace('quicksell', '');
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';		
						
			rate = parseFloat(document.getElementById('sell'+selectcur+'rate').value);
			selectunit = document.getElementById(type+'dir').value;

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				
				ngnamount = (usdamount * rate);
				ngnamount = Round(2,ngnamount);
				document.getElementById('quicksellusdtamt').value = ngnamount;
				ngnamount = Rounder(ngnamount);
				
				if(isNaN(usdamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				summarydisplay += 'Receive Total <b>&#8358;'+ngnamount+'</b>';
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
		
		if(type.slice(0, -3) === 'sendu'){
			selectcur = type.replace('send', '');
			usdamount = parseFloat(document.getElementById(amount).value);
			summarydisplay = '';					
			selectunit = document.getElementById(type+'dir').value;

			if(usdamount !== '' && !isNaN(usdamount) && selectcur !== '' && selectunit === 'USD')
			{
				usdbtc = parseFloat(document.getElementById('usd'+selectcur).value);
				
				summarydisplay += '<b>~ '+usdamount+' '+selectcur.toUpperCase()+'</b><br/>';
				if(isNaN(usdamount)){
					document.getElementById(display).innerHTML = "";
					document.getElementById(display).style.display = 'none';
					return false;
				}
				
				document.getElementById(display).innerHTML = summarydisplay;
				document.getElementById(display).style.display = 'block';
			}
			else
			{
				document.getElementById(display).style.display = 'none';
			}
		}
				
	}
		
	function lookUp(field, type)
	{
		
		var val, look, t, currency, acctresolved, acctname, regresolved;
		
		val = document.getElementById(field).value;
		val = val.trim();
		look = localStorage.getItem(field+"lookUp");	
		
		if(type === 'pm'){
			//display other account field	
			val = val.toUpperCase();
			t = field.slice(0, -7);
			
			currency = document.getElementById('buycurrency').value.toLowerCase();		
			acctresolved = t+'acct';
			acctname = t+'accountname';
			
			if(currency === 'pm'){
				document.getElementById(acctresolved).value = '0';
				document.getElementById(acctname).value = '';
			}
			if(look === val){
				return false;
			}
			
			document.getElementById(field+'summary').className = 'incsizespan center'; 
			if(val.length > 7 && val.length <= 9 && currency === 'pm'){
				document.getElementById(field+'summary').innerHTML = 'Validating Account...';
				document.getElementById(field+'summary').style.display = 'block';
			}else if(val.length >= 10 && currency === 'pm'){
				document.getElementById(field+'summary').innerHTML = 'Validating Account...';
				document.getElementById(field+'summary').style.display = 'block';
				document.getElementById(field+'summary').className = 'incsizespan incsizespan_error';
				document.getElementById(field+'summary').innerHTML = '<b>'+val+'</b> is an Invalid Perfect Money Account';
				document.getElementById(field+'summary').style.display = 'block';
				return false;
			}else{
				document.getElementById(field+'summary').innerHTML = '';
				document.getElementById(field+'summary').style.display = 'none';
				localStorage.setItem(field+"lookUp", "");
				return false;
			}
			localStorage.setItem(field+"lookUp", val);
		}
		
		if(type === 'cc'){
			
			t = field.slice(0, -5);
			regresolved = t+'reg';
			document.getElementById(regresolved).value = '0';
			document.getElementById(t+'emailsummary').className = 'incsizespan center';
			if(t === 'sell'){
				document.getElementById('sellbanksummary').className = 'incsizespan center';
			}
			
			if(look === val){
				return false;
			}
			
			if(validateEmail(val)){
				document.getElementById(t+'emailsummary').innerHTML = 'Validating email...';
				document.getElementById(t+'emailsummary').style.display = 'block';
			}else if(isNumeric(val) && val.length >= 11 && val.length <= 13){
				document.getElementById(t+'emailsummary').innerHTML = 'Validating phone...';
				document.getElementById(t+'emailsummary').style.display = 'block';
			}else{
				document.getElementById(t+'emailsummary').innerHTML = '';
				document.getElementById(t+'emailsummary').style.display = 'none';
				localStorage.setItem(field+"lookUp", "");
				return false;
			}
			localStorage.setItem(field+"lookUp", val);
		}
		output = {
			type: type,
			search: val,
			product: t,
			field: field,
			acctname: acctname,
			acctresolved: acctresolved,
			regresolved: regresolved,
			key: localStorage.getItem('_key')
		};
		nameLookUp(output);		
	}
	
	
	//ONSWITCH CHANGE
	const handleSwitchChange2 = (e) => {
		//e.preventDefault()
		var target, thisid, thiscurid, thistype, thiscur;
        target = e.target;
        thisid = target.id;
		thiscurid = thisid.slice(0, -3);
		thistype = thiscurid.slice(0, -3);
		thiscur = document.getElementById('cryptoselected').value;
        
        if(target.checked){
			document.getElementById(thistype+thiscur.toLowerCase()+'amount').setAttribute('placeholder', 'Amount In '+thiscur);
			document.getElementById(thistype+thiscur.toLowerCase()+'dir').value = thiscur;
			document.getElementById(thistype+thiscur.toLowerCase()+'dirdisplay').innerHTML = thiscur;
			if(thistype === 'quicksell'){
				document.getElementById(thistype+thiscur.toLowerCase()+'feedback').innerHTML = '';
				document.getElementById(thistype+thiscur.toLowerCase()+'feedback').className = 'incsizespan center';
				if(thiscur === 'BTC'){
					setQuickSellBTCdir(thiscur);
					SkyCalculate('bt', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'USDT'){
					//setQuickSellUSDTdir(thiscur);
					SkyCalculate('usdt', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'BCH'){
					setQuickSellBCHdir(thiscur);
					SkyCalculate('alt', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'ETH'){
					setQuickSellETHdir(thiscur);
					SkyCalculate('alt', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'LTC'){
					setQuickSellLTCdir(thiscur);
					SkyCalculate('alt', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}		
			}else if(thistype === 'send'){				
				if(thiscur === 'BTC'){
					setSendBTCdir(thiscur);
					SkyCalculate('bten', 'bt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'USDT'){
					//setSendUSDTdir(thiscur);
					SkyCalculate('usdten', 'usdt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'BCH'){
					setSendBCHdir(thiscur);
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'ETH'){
					setSendETHdir(thiscur);
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'LTC'){
					setSendLTCdir(thiscur);
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}
			}
        }else{
			document.getElementById(thistype+thiscur.toLowerCase()+'amount').setAttribute('placeholder', 'Amount In USD');
			document.getElementById(thistype+thiscur.toLowerCase()+'dir').value = 'USD';
			document.getElementById(thistype+thiscur.toLowerCase()+'dirdisplay').innerHTML = 'USD';			
			if(thistype === 'quicksell'){
				document.getElementById(thistype+thiscur.toLowerCase()+'feedback').innerHTML = '';
				document.getElementById(thistype+thiscur.toLowerCase()+'feedback').className = 'incsizespan center';
				if(thiscur === 'BTC'){
					setQuickSellBTCdir('USD');
					SkyCalculate('bten', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'USDT'){
					//setQuickSellUSDTdir('USD');
					SkyCalculate('usdten', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'BCH'){
					setQuickSellBCHdir('USD');
					SkyCalculate('alten', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'ETH'){
					setQuickSellETHdir('USD');
					SkyCalculate('alten', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'LTC'){
					setQuickSellLTCdir('USD');
					SkyCalculate('alten', 'cc', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}			
			}else if(thistype === 'send'){				
				if(thiscur === 'BTC'){
					setSendBTCdir('USD');
					SkyCalculate('bten', 'bt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'USDT'){
					//setSendUSDTdir('USD');
					SkyCalculate('usdten', 'usdt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'BCH'){
					setSendBCHdir('USD');
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'ETH'){
					setSendETHdir('USD');
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}else if(thiscur === 'LTC'){
					setSendLTCdir('USD');
					SkyCalculate('alten', 'alt', thistype+thiscur.toLowerCase()+'amount', thistype+thiscur.toLowerCase()+'summary');
				}
			}
        }       
    }
	
	const depositAllBTC = (field) => {
		//e.preventDefault()
		//sendbtc,sendbtcamount
	}
	
	const depositAllUSDT = (e) => {
		//e.preventDefault()
		//sendusdt,sendusdtamount
	}
	
	const depositAllBCH = (e) => {
		//e.preventDefault()
		//sendbtc,sendbtcamount
	}
	
	const depositAllETH = (e) => {
		//e.preventDefault()
		//sendbtc,sendbtcamount
	}	
	const depositAllLTC = (e) => {
		//e.preventDefault()
		//sendbtc,sendbtcamount
	}	
	function toggleAcc(itemId, togglerId) 
	{
		var i, j, accItems = document.getElementsByClassName('acc__item'), accTogglers = document.getElementsByClassName('acc__toggler');
		
		for (i = 0; i < accTogglers.length; i++) {
			if(accTogglers[i].id === togglerId){
				accTogglers[i].className = 'acc__toggler acc__togglerbg';
			}else{
				accTogglers[i].className = 'acc__toggler';
			}
		}
		for (j = 0; j < accItems.length; j++) {
			if(accItems[j].id !== itemId){
				accItems[j].className = 'acc__item';
			}
		}
		if (document.getElementById(itemId).className === 'acc__item') {
			document.getElementById(itemId).className = 'acc__item active';
		}else{
			document.getElementById(itemId).className = 'acc__item';
			document.getElementById(togglerId).className = 'acc__toggler';
		}
    }
	const handleClick1 = (e) => {
		e.preventDefault();
		toggleAcc('acc__item1', 'acc__toggler1');
    }
	const handleClick2 = (e) => {
		e.preventDefault();
		toggleAcc('acc__item2', 'acc__toggler2');
    }
	const handleClick3 = (e) => {
		e.preventDefault();
		toggleAcc('acc__item3', 'acc__toggler3');
    }	
	function toggleCur(itemId, cur) 
	{		
		var i, j, k, cryptoItems = document.getElementsByClassName('crypto__btn'), coinwrapperItems = document.getElementsByClassName('coinwrapper'),  modeSwitchControlItems = document.getElementsByClassName('modeSwitchControl'), curl = cur.toLowerCase();		
		document.getElementById('cryptoselected').value = cur;	
		for (i = 0; i < coinwrapperItems.length; i++) {
			if(coinwrapperItems[i].id === curl+'wrapper'){
				coinwrapperItems[i].className = 'coinwrapper show';
			}else{
				coinwrapperItems[i].className = 'coinwrapper hide';
			}
		}		
		for (k = 0; k < modeSwitchControlItems.length; k++) {
			if(modeSwitchControlItems[k].id === curl+'modeSwitchControl'){
				modeSwitchControlItems[k].className = 'modeSwitchControl show';
			}else{
				modeSwitchControlItems[k].className = 'modeSwitchControl hide';
			}
		}		
		for (j = 0; j < cryptoItems.length; j++) {
			if(cryptoItems[j].id !== itemId){
				cryptoItems[j].className = 'crypto__btn';
			}
		}		
		if (document.getElementById(itemId).className === 'crypto__btn') {
			document.getElementById(itemId).className = 'crypto__btn active'
		}
    }
	const handleCurClick1 = (e) => {
		e.preventDefault();
		toggleCur('crypto__btc', 'BTC');
    }	
	const handleCurClick2 = (e) => {
		//return false;
		// eslint-disable-next-line
		e.preventDefault();
		toggleCur('crypto__usdt', 'USDT');
    }	
	const handleCurClick3 = (e) => {
		return false;
		// eslint-disable-next-line
		e.preventDefault();
		toggleCur('crypto__bch', 'BCH');
    }
	const handleCurClick4 = (e) => {
		return false;
		// eslint-disable-next-line
		e.preventDefault();
		toggleCur('crypto__eth', 'ETH');
    }
	const handleCurClick5 = (e) => {
		return false;
		// eslint-disable-next-line
		e.preventDefault();
		toggleCur('crypto__ltc', 'LTC');
    }	
	
	function switchAction(cur, targetid) 
	{
		var xprev1 = document.getElementById(cur+'switch-btn__check').getAttribute('data-level');
		var xprev = xprev1.replace(/\s/g, '');
		var sxprev = xprev.toLowerCase();
		var xval1 = document.getElementById(targetid).innerHTML;
		var xval = xval1.replace(/\s/g, '');
		var sxval = xval.toLowerCase();
		
		if(xprev === 'QUICKSELL' && xval === 'SEND'){				
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(100%)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}else if(xprev === 'QUICKSELL' && xval === 'RECEIVE'){			
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(200%)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}else if(xprev === 'SEND' && xval === 'RECEIVE'){
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(200%)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}else if(xprev === 'SEND' && xval === 'QUICKSELL'){
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(0)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}else if(xprev === 'RECEIVE' && xval === 'SEND'){
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(100%)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}else if(xprev === 'RECEIVE' && xval === 'QUICKSELL'){
			document.getElementById(sxprev+cur).className = "hide";
			document.getElementById(sxval+cur).className = "stack show";
			document.getElementById(cur+'switch-btn__marker').style.transform = "translateX(0)";
			document.getElementById(cur+'switch-btn__check').setAttribute('data-level', xval1);
		}
    }
	
	
	const btcSwitch = (e) => {
		e.preventDefault();
		var targetid = e.target.id;
		switchAction('btc', targetid);	
	}
	const usdtSwitch = (e) => {
		e.preventDefault();
		var targetid = e.target.id;
		switchAction('usdt', targetid);	
	}
	const bchSwitch = (e) => {
		e.preventDefault();
		var targetid = e.target.id;
		switchAction('bch', targetid);		
	}
	const ltcSwitch = (e) => {
		e.preventDefault();
		var targetid = e.target.id;
		switchAction('ltc', targetid);	
	}
	const ethSwitch = (e) => {
		e.preventDefault();
		var targetid = e.target.id;
		switchAction('eth', targetid);
	}
	
	function ScanQR()
	{
		window.LaunchQR();		
	}
	
	//console.log(dashboardparams);
	if(!dashboardparams.firstname)
	{
		return (<FullLoader />);
	}
	else
	{
		return [
		(			
			<div key="dash1" className="container__canvas" style={rectStyleWrap}><div key="dash2" name="fadeStart" id="dv0"> <div key="dash3" className="tooltip"> <ul className="notification-list"> <li key="notification-item" className="notification-item"> <div key="dash4" className="img-left"> <svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet"> <g className="layer"> <g fill="#000000" id="svg_1" transform="translate(0, 160) scale(0.1, -0.1)"> <path d="m112.7258,1553.26096c-31.91754,-21.26496 -41.49282,-29.60415 -56.99562,-49.20126c-8.66333,-10.84096 -15.50281,-20.84799 -15.50281,-22.93279c0,-1.66784 -3.19175,-8.33919 -7.29544,-15.42752c-17.78263,-31.27199 -15.04685,-99.65339 5.47157,-139.26457c15.50281,-30.43806 60.64335,-70.88316 95.29667,-85.89371c24.16614,-10.424 76.60211,-20.43102 82.07369,-15.42752c0.91194,1.25089 -5.92754,6.67136 -15.95878,12.92575c-21.88632,13.34271 -36.4772,31.27199 -56.53966,69.21533c-20.97439,40.4451 -27.3579,75.88668 -24.16614,137.17977c2.27982,44.19773 8.66333,74.6358 21.43036,105.49083c7.29544,16.67838 -5.01561,18.34623 -27.81386,3.33568l0,0l0,0.00001l0.00001,-0.00001l0.00001,0z" id="svg_3"/> <path d="m239.48405,1540.33521c-11.39912,-10.424 -27.3579,-30.43806 -35.56527,-44.6147c-12.76702,-22.09887 -15.50281,-30.85502 -16.87071,-62.127c-1.82386,-30.0211 -0.91194,-37.10943 5.01561,-39.19422c10.48719,-3.33568 77.97001,33.77374 104.87194,58.37437c13.22299,11.67488 27.81386,28.35326 32.37351,36.69246l9.11929,15.42752l-24.62211,20.84799c-13.67895,11.67488 -28.26983,22.51582 -32.82948,23.76671c-4.55965,1.25089 -8.20737,4.1696 -8.20737,6.25439c0,8.75616 -14.13492,2.50175 -33.28544,-15.42752l0,0l0,-0.00001l0.00002,-0.00001l0.00001,0.00001z" id="svg_4"/> <path d="m366.69829,1456.52628c-9.57526,-26.26846 -87.08931,-81.30716 -135.42159,-95.48379c-12.31105,-3.75264 -23.71018,-8.33919 -25.07807,-10.424c-1.3679,-2.0848 5.47157,-17.09535 15.04685,-33.77374c17.78263,-31.27199 60.64335,-74.21884 73.86633,-74.21884c4.10368,0 17.78263,8.33919 30.09369,18.34623c52.89193,42.11294 75.23421,118.41658 52.89193,181.79448c-6.83947,19.59711 -8.20737,21.68191 -11.39912,13.75967l0,0l-0.00001,0l-0.00001,-0.00001z" id="svg_5"/> </g> </g> </svg> </div> <div key="dash5" className="user-content"> <p className="user-info"><span className="name">{fullname}</span></p> <p className="time">Status: {verify === '0' ? 'Unverified' : 'Verified'}</p> </div></li> </ul> </div></div><div key="dash6" className="Context"> {verify === '1' ? (<DashboardNavBar key="dv1oo" />) : (<DashboardNavBar2 key="dv2oo" />)} </div> </div>	
		),
		(	
		<div key="main-container">
			{verify === '0' && fullname ? (<Redirect key="dv4" to="/bank"/>) : ('')}
			<div key="dash7" className="wallet__content stack-15">
			<div key="dash8" className="p-options__wrapper card-base">
				<div key="dash9" className="acc__wrap">
					<div key="dash10" className="acc__item" id="acc__item1">
						<div key="dash11" className="acc__toggler" id="acc__toggler1" onClick={handleClick1}>
							<div key="dash12" className="payment-name">
								<div key="dash13" className="pname">ENDOPAY ACCOUNT</div> 
								<div key="dash14" className="pimg">
								<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
							 <g className="layer">
							  <g fill="#000000" id="svg_1" transform="translate(0, 160) scale(0.1, -0.1)">
							   <path d="m112.7258,1553.26096c-31.91754,-21.26496 -41.49282,-29.60415 -56.99562,-49.20126c-8.66333,-10.84096 -15.50281,-20.84799 -15.50281,-22.93279c0,-1.66784 -3.19175,-8.33919 -7.29544,-15.42752c-17.78263,-31.27199 -15.04685,-99.65339 5.47157,-139.26457c15.50281,-30.43806 60.64335,-70.88316 95.29667,-85.89371c24.16614,-10.424 76.60211,-20.43102 82.07369,-15.42752c0.91194,1.25089 -5.92754,6.67136 -15.95878,12.92575c-21.88632,13.34271 -36.4772,31.27199 -56.53966,69.21533c-20.97439,40.4451 -27.3579,75.88668 -24.16614,137.17977c2.27982,44.19773 8.66333,74.6358 21.43036,105.49083c7.29544,16.67838 -5.01561,18.34623 -27.81386,3.33568l0,0l0,0.00001l0.00001,-0.00001l0.00001,0z" id="svg_3"/>
							   <path d="m239.48405,1540.33521c-11.39912,-10.424 -27.3579,-30.43806 -35.56527,-44.6147c-12.76702,-22.09887 -15.50281,-30.85502 -16.87071,-62.127c-1.82386,-30.0211 -0.91194,-37.10943 5.01561,-39.19422c10.48719,-3.33568 77.97001,33.77374 104.87194,58.37437c13.22299,11.67488 27.81386,28.35326 32.37351,36.69246l9.11929,15.42752l-24.62211,20.84799c-13.67895,11.67488 -28.26983,22.51582 -32.82948,23.76671c-4.55965,1.25089 -8.20737,4.1696 -8.20737,6.25439c0,8.75616 -14.13492,2.50175 -33.28544,-15.42752l0,0l0,-0.00001l0.00002,-0.00001l0.00001,0.00001z" id="svg_4"/>
							   <path d="m366.69829,1456.52628c-9.57526,-26.26846 -87.08931,-81.30716 -135.42159,-95.48379c-12.31105,-3.75264 -23.71018,-8.33919 -25.07807,-10.424c-1.3679,-2.0848 5.47157,-17.09535 15.04685,-33.77374c17.78263,-31.27199 60.64335,-74.21884 73.86633,-74.21884c4.10368,0 17.78263,8.33919 30.09369,18.34623c52.89193,42.11294 75.23421,118.41658 52.89193,181.79448c-6.83947,19.59711 -8.20737,21.68191 -11.39912,13.75967l0,0l-0.00001,0l-0.00001,-0.00001z" id="svg_5"/>
							  </g>
							 </g>
							</svg></div>
							</div>
						</div>
						<div key="dash15" className="acc__content">
							<div key="dash16" className="po-wrap">
								<div key="dash17" className="po-crypto__step-1">
									<p className="text-uppercase help-text available" id="ngnbaldisplay" dangerouslySetInnerHTML={{__html:`Available Balance: <b>&#8358;0.00</b>`}}></p>
									<div key="dash18" className="crypto-list__row ">
										
										<div key="dash19" className="po-ctypto__email-step-transition">
										
											<div key="dash20" className="stack po-crypto__email-step" >	
												<p><span>
												<svg width="40" height="40" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="xMidYMid meet">
												 <g className="layer">
												  <g fill="#000000" id="svg_1" transform="translate(0, 160) scale(0.1, -0.1)">
												   <path d="m112.7258,1553.26096c-31.91754,-21.26496 -41.49282,-29.60415 -56.99562,-49.20126c-8.66333,-10.84096 -15.50281,-20.84799 -15.50281,-22.93279c0,-1.66784 -3.19175,-8.33919 -7.29544,-15.42752c-17.78263,-31.27199 -15.04685,-99.65339 5.47157,-139.26457c15.50281,-30.43806 60.64335,-70.88316 95.29667,-85.89371c24.16614,-10.424 76.60211,-20.43102 82.07369,-15.42752c0.91194,1.25089 -5.92754,6.67136 -15.95878,12.92575c-21.88632,13.34271 -36.4772,31.27199 -56.53966,69.21533c-20.97439,40.4451 -27.3579,75.88668 -24.16614,137.17977c2.27982,44.19773 8.66333,74.6358 21.43036,105.49083c7.29544,16.67838 -5.01561,18.34623 -27.81386,3.33568l0,0l0,0.00001l0.00001,-0.00001l0.00001,0z" id="svg_3"/>
												   <path d="m239.48405,1540.33521c-11.39912,-10.424 -27.3579,-30.43806 -35.56527,-44.6147c-12.76702,-22.09887 -15.50281,-30.85502 -16.87071,-62.127c-1.82386,-30.0211 -0.91194,-37.10943 5.01561,-39.19422c10.48719,-3.33568 77.97001,33.77374 104.87194,58.37437c13.22299,11.67488 27.81386,28.35326 32.37351,36.69246l9.11929,15.42752l-24.62211,20.84799c-13.67895,11.67488 -28.26983,22.51582 -32.82948,23.76671c-4.55965,1.25089 -8.20737,4.1696 -8.20737,6.25439c0,8.75616 -14.13492,2.50175 -33.28544,-15.42752l0,0l0,-0.00001l0.00002,-0.00001l0.00001,0.00001z" id="svg_4"/>
												   <path d="m366.69829,1456.52628c-9.57526,-26.26846 -87.08931,-81.30716 -135.42159,-95.48379c-12.31105,-3.75264 -23.71018,-8.33919 -25.07807,-10.424c-1.3679,-2.0848 5.47157,-17.09535 15.04685,-33.77374c17.78263,-31.27199 60.64335,-74.21884 73.86633,-74.21884c4.10368,0 17.78263,8.33919 30.09369,18.34623c52.89193,42.11294 75.23421,118.41658 52.89193,181.79448c-6.83947,19.59711 -8.20737,21.68191 -11.39912,13.75967l0,0l-0.00001,0l-0.00001,-0.00001z" id="svg_5"/>
												  </g>
												 </g>
												</svg>  WITHDRAW TO BANK</span></p>
												
												<span className="help-text">
													<p>
														<b>SEND TO BANK ACCOUNT</b><br/>You are sending payment to your registered default bank account. <span className="tooltiplink">Learn more</span>
													</p>
												</span>	
												
												<div key="dash21" className="container__control--input">
													<input className="text-input" type="text" name="withdrawamount" id="withdrawamount" placeholder="Amount In NGN" value={withdrawamount} onChange={(e) => setWithdrawAmount(e.target.value)} onKeyUp={handleKeyUp} />
												</div>
												
												<div key="dash22" className="incsizespan center" id="withdrawsummary">	
												</div>
												
												{verify === '1' ? (<div key="dash23" className="incsizespansms center" id="withdrawemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
												</div>) : (<div key="dash24" className="incsizespansms center" id="withdrawemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
												</div>)}										
												<div key="dash25" className="container__control--input password fixpost">
													<input className="text-input" type="password" name="withdrawconfirmationcode" id="withdrawconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password" />
													<span className="action_password icon-eye"></span>
												</div>											
												<div key="dash26" className="incsizespan center" id="withdrawfeedback">
													
												</div>											
												<div key="dash27" className="container__buttons">
													<button className="clipboard" id="withdrawproceed" onClick={onSubmitWithdraw}>PROCEED</button>
												</div>								
											</div>
										</div>
										
									</div>
								</div>
							</div>
						</div>
						
					</div>
					<div key="dash28" className="acc__item" id="acc__item2">
						<div key="dash29" className="acc__toggler" id="acc__toggler2" onClick={handleClick2}>
							<div key="dash30" className="payment-name">
								<div key="dash31" className="pname">CRYPTO WALLETS</div> 
								<div key="dash32" className="pimg"><img src={CRYPTOLogo} alt="Crypto wallets" className="img-responsive acc__toggler-icons"/></div>
							</div>
						</div> 
						<div key="dash33" className="acc__content">
							<div key="dash34" className="po-wrap">
								<div key="dash35" className="po-crypto__step-1">
									<p className="text-uppercase help-text mb-15"> Choose a wallet </p>
									<input type="hidden" value="BTC" id="cryptoselected"/>
									<div key="dash36" className="crypto-list__row ">
									
										<div key="dash37" className="crypto-list__col">
											<button className="crypto__btn active" id="crypto__btc" onClick={handleCurClick1}><span className="crypto__ico-wrap"><span className="crypto__ico btc"></span></span> Bitcoin </button>
										</div>
										<div key="dash38" className="crypto-list__col">
											<button className="crypto__btn" id="crypto__usdt" onClick={handleCurClick2}><span className="crypto__ico-wrap"><span className="crypto__ico usdt"></span></span> Tether USD </button>
										</div>
										
										{/*<div key="dash39" className="crypto-list__col">
											<button className="crypto__btn" id="crypto__bch" onClick={handleCurClick3}><span className="crypto__ico-wrap"><span className="crypto__ico bch"></span></span> Bitcoin Cash </button>
										</div>
										<div key="dash40" className="crypto-list__col">
											<button className="crypto__btn" id="crypto__eth" onClick={handleCurClick4}><span className="crypto__ico-wrap"><span className="crypto__ico eth"></span></span> Ethereum </button>
										</div>
										<div key="dash41" className="crypto-list__col">
											<button className="crypto__btn" id="crypto__ltc" onClick={handleCurClick5}><span className="crypto__ico-wrap"><span className="crypto__ico ltc"></span></span> Litecoin </button>
										</div>*/}
										
										<div key="dash42" className="po-ctypto__email-step-transition">
											<div key="dash43" className="po-crypto__email-step container__control--switch" >
											
												<div key="dash44" className="modeSwitchControl show" id="btcmodeSwitchControl">
													<p><img src={BTCLogo} alt="Crypto wallets" className="wallet_icons" /><span>  Bitcoin Wallet</span></p>
													<button className="switch-btn" id="btcmodeSwitch">
														<span id="btcswitch-btn__check" data-level="QUICK SELL" className="hide"></span>
														<span className="switch-btn__marker" id="btcswitch-btn__marker"></span>
														<span className="center-xy switch-btn__label" id="btcwalletbtn1" onClick={btcSwitch}>QUICK SELL</span>
														<span className="center-xy switch-btn__label" id="btcwalletbtn2" onClick={btcSwitch}>SEND</span>
														<span className="center-xy switch-btn__label" id="btcwalletbtn3" onClick={btcSwitch}>RECEIVE</span>
													</button>
												</div>
												
												<div key="dash45" className="modeSwitchControl hide" id="usdtmodeSwitchControl">
													<p><img src={USDTLogo} alt="Crypto wallets" className="wallet_icons" /><span> Tether USD Wallet</span></p>
													<button className="switch-btn" id="usdtmodeSwitch">
														<span id="usdtswitch-btn__check" data-level="QUICK SELL" className="hide"></span>
														<span className="switch-btn__marker" id="usdtswitch-btn__marker"></span>
														<span className="center-xy switch-btn__label" id="usdtwalletbtn1" onClick={usdtSwitch}>QUICK SELL</span>
														<span className="center-xy switch-btn__label" id="usdtwalletbtn2" onClick={usdtSwitch}>SEND</span>
														<span className="center-xy switch-btn__label" id="usdtwalletbtn3" onClick={usdtSwitch}>RECEIVE</span>
													</button>
												</div>
												
												<div key="dash46" className="modeSwitchControl hide" id="bchmodeSwitchControl">
													<p><img src={BCHLogo} alt="Crypto wallets" className="wallet_icons" /><span>  Bitcoin Cash Wallet</span></p>
													<button className="switch-btn" id="bchmodeSwitch">
														<span id="bchswitch-btn__check" data-level="QUICK SELL" className="hide"></span>
														<span className="switch-btn__marker" id="bchswitch-btn__marker"></span>
														<span className="center-xy switch-btn__label" id="bchwalletbtn1" onClick={bchSwitch}>QUICK SELL</span>
														<span className="center-xy switch-btn__label" id="bchwalletbtn2" onClick={bchSwitch}>SEND</span>
														<span className="center-xy switch-btn__label" id="bchwalletbtn3" onClick={bchSwitch}>RECEIVE</span>
													</button>
												</div>
												
												<div key="dash47" className="modeSwitchControl hide" id="ethmodeSwitchControl">
													<p><img src={ETHLogo} alt="Crypto wallets" className="wallet_icons" /><span>  Ethereum Wallet</span></p>
													<button className="switch-btn" id="ethmodeSwitch">
														<span id="ethswitch-btn__check" data-level="QUICK SELL" className="hide"></span>
														<span className="switch-btn__marker" id="ethswitch-btn__marker"></span>
														<span className="center-xy switch-btn__label" id="ethwalletbtn1" onClick={ethSwitch}>QUICK SELL</span>
														<span className="center-xy switch-btn__label" id="ethwalletbtn2" onClick={ethSwitch}>SEND</span>
														<span className="center-xy switch-btn__label" id="ethwalletbtn3" onClick={ethSwitch}>RECEIVE</span>
													</button>
												</div>
												
												<div key="dash48" className="modeSwitchControl hide" id="ltcmodeSwitchControl">
													<p><img src={LTCLogo} alt="Crypto wallets" className="wallet_icons" /><span>  Litecoin Wallet</span></p>
													<button className="switch-btn" id="ltcmodeSwitch">
														<span id="ltcswitch-btn__check" data-level="QUICK SELL" className="hide"></span>
														<span className="switch-btn__marker" id="ltcswitch-btn__marker"></span>
														<span className="center-xy switch-btn__label" id="ltcwalletbtn1" onClick={ltcSwitch}>QUICK SELL</span>
														<span className="center-xy switch-btn__label" id="ltcwalletbtn2" onClick={ltcSwitch}>SEND</span>
														<span className="center-xy switch-btn__label" id="ltcwalletbtn3" onClick={ltcSwitch}>RECEIVE</span>
													</button>
												</div>
												
												<div key="dash49" className="coinwrapper show" id="btcwrapper">
													<div key="dash50" className="stack show" id="quicksellbtc">
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableBTC1" dangerouslySetInnerHTML={{__html:`Bal: <b>0 BTC</b>`}}></p>
															<p>
																<b>SEND TO BANK ACCOUNT</b><br/>Your deposit needs to have at least 1 confirmation on blockchain to get payment to bank instantly, else it will queued until your deposit achieve the confirmation. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														
														<>
															<label id="quicksellbtcdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="quicksellbtcdir" id="quicksellbtcdir" value={quicksellbtcdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="quicksellbtcdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash51" className="incsizespansms">
															<label htmlFor="quicksellsendallbtc"><input type="checkbox" id="quicksellsendallbtc" name="quicksellsendallbtc" onClick={depositAllBTC('quicksell')} /> Sell Available BTC </label>
														</div>
														
														<div key="dash52" className="container__control--input">
															<input className="text-input" type="text" name="quicksellbtcamount" id="quicksellbtcamount" placeholder="Amount In USD" value={quicksellbtcamount} onChange={(e) => setQuickSellBTCAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash53" className="incsizespan center" id="quicksellbtcsummary">
															
														</div>	
														
														
														{verify === '1' ? (<div key="dash54" className="incsizespansms center" id="quicksellbtcemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
														</div>) : (<div key="dash55" className="incsizespansms center" id="quicksellbtcemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
														</div>)}
														
														<div key="dash56" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="quicksellbtcconfirmationcode" id="quicksellbtcconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"/>
															<span className="action_password icon-eye"></span>
														</div>		
														
														<div key="dash57" className="incsizespan center" id="quicksellbtcfeedback">
															
														</div>
														
														<div key="dash58" className="container__buttons">
															<button className="clipboard" id="quicksellbtcproceed" onClick={onSubmitQuickSellBTC}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash59" className="hide" id="sendbtc">	
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableBTC2" dangerouslySetInnerHTML={{__html:`Bal: <b>0 BTC</b>`}}></p>
															<p>
																<b>MAKE SURE THE ADDRESS YOU HAVE PASTED IS THE SAME AS THE ADDRESS YOU HAVE COPIED!</b><br/>Some users have gotten their funds stolen by malware replacing the address copied to clipboard with the attackers address. <span className="tooltiplink">Learn more</span> 
															</p>
														</span>	
														
														<>
															<label id="sendbtcdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="sendbtcdir" id="sendbtcdir" value={sendbtcdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="sendbtcdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash60" className="incsizespansms">
															<label htmlFor="sendbtcsendall"><input type="checkbox" id="sendbtcsendall" name="sendbtcsendall" onClick={depositAllBTC('sendbtc')} /> Send Available BTC </label>
														</div>
														
														<div key="dash61" className="container__control--input">
															<input className="text-input" type="text" name="sendbtcamount" id="sendbtcamount" placeholder="Amount In USD" value={sendbtcamount} onChange={(e) => setSendBTCAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash62" className="incsizespan center" id="sendbtcsummary">
															
														</div>
														
														<div key="dash63" className="container__control--input scan fixpost">
															<input className="text-input" type="text" name="sendbtcaddress" id="sendbtcaddress" placeholder="BTC Address" />
															<span id="sendbtccamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
														</div>								
														
														<div key="dash64" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="sendbtcconfirmationcode" id="sendbtcconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"  />
															<span className="action_password icon-eye"></span>
														</div>						
														
														<div key="dash65" className="incsizespan center" id="sendbtcemailsummary">
															
														</div>	
														
														<div key="dash66" className="incsizespan center" id="sendbtcfeedback">
															
														</div>
														
														<div key="dash67" className="container__buttons">
															<button className="clipboard" id="sendbtcproceed" onClick={onSubmitSendBTC}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash68" className="hide" id="receivebtc">	
													
														<span className="help-text">
															<p>
																<b>SEND ONLY BTC TO THIS DEPOSIT ADDRESS</b><br/>Sending coin or token other than BTC to this address may result in the loss of your deposit. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														<div key="dash69" className="container__control--input" id="receivebtcdisplay">
															
														</div>
														<div key="dash70" className="container__buttons">
															<button className="clipboard" id="receivebtcproceed">$0.00</button>
														</div>		
													</div>
												</div>
												
												
												<div key="dash71" className="coinwrapper hide" id="usdtwrapper">
													<div key="dash72" className="stack show" id="quicksellusdt">
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableUSDT1" dangerouslySetInnerHTML={{__html:`Bal: <b>0 USDT</b>`}}></p>
															<p>
																<b>SEND TO BANK ACCOUNT</b><br/>Your deposit needs to have at least 20 confirmations on blockchain to get payment to bank instantly, else it will queued until your deposit achieve the confirmation. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														
														<input type="hidden" name="quicksellusdtdir" id="quicksellusdtdir" value={quicksellusdtdir} tabIndex="1" />
																						
														<div key="dash73" className="incsizespansms">
															<label htmlFor="quicksellsendallusdt"><input type="checkbox" id="quicksellsendallusdt" name="quicksellsendallusdt" onClick={depositAllUSDT} /> Sell Available USDT </label>
														</div>
														
														<div key="dash74" className="container__control--input">
															<input className="text-input" type="text" name="quicksellusdtamount" id="quicksellusdtamount" placeholder="Amount In USD" value={quicksellusdtamount} onChange={(e) => setQuickSellUSDTAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash75" className="incsizespan center" id="quicksellusdtsummary">
															
														</div>	
														
														
														{verify === '1' ? (<div key="dash76" className="incsizespansms center" id="quicksellusdtemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
														</div>) : (<div key="dash77" className="incsizespansms center" id="quicksellusdtemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
														</div>)}
														
														<div key="dash78" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="quicksellusdtconfirmationcode" id="quicksellusdtconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password" />
															<span className="action_password icon-eye"></span>
														</div>		
														
														<div key="dash79" className="incsizespan center" id="quicksellusdtfeedback">
															
														</div>
														
														<div key="dash80" className="container__buttons">
															<button className="clipboard" id="quicksellusdtproceed" onClick={onSubmitQuickSellUSDT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash81" className="hide" id="sendusdt">	
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableUSDT2" dangerouslySetInnerHTML={{__html:`Bal: <b>0 USDT</b>`}}></p>
															<p>
																<b>MAKE SURE THE ADDRESS YOU HAVE PASTED IS THE SAME AS THE ADDRESS YOU HAVE COPIED!</b><br/>Some users have gotten their funds stolen by malware replacing the address copied to clipboard with the attackers address. <span className="tooltiplink">Learn more</span> 
															</p>
														</span>	
														
														<input type="hidden" name="sendusdtdir" id="sendusdtdir" value={sendusdtdir} tabIndex="1" />
														
																						
														<div key="dash82" className="incsizespansms">
															<label htmlFor="sendusdtsendall"><input type="checkbox" id="sendusdtsendall" name="sendusdtsendall" onClick={depositAllUSDT} /> Send Available USDT </label>
														</div>
														
														<div key="dash83" className="container__control--input">
															<input className="text-input" type="text" name="sendusdtamount" id="sendusdtamount" placeholder="Amount In USD" value={sendusdtamount} onChange={(e) => setSendUSDTAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash84" className="incsizespan center" id="sendusdtsummary">
															
														</div>
														
														<div key="dash85" className="container__control--input scan fixpost">
															<input className="text-input" type="text" name="sendusdtaddress" id="sendusdtaddress" placeholder="USDT (TRC20) Address" />
															<span id="sendusdtcamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
														</div>								
														
														<div key="dash86" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="sendusdtconfirmationcode" id="sendusdtconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"  />
															<span className="action_password icon-eye"></span>
														</div>						
														
														<div key="dash87" className="incsizespan center" id="sendusdtemailsummary">
															
														</div>	
														
														<div key="dash88" className="incsizespan center" id="sendusdtfeedback">
															
														</div>
														
														<div key="dash89" className="container__buttons">
															<button className="clipboard" id="sendusdtproceed" onClick={onSubmitSendUSDT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash90" className="hide" id="receiveusdt">	
													
														<span className="help-text">
															<p>
																<b>SEND ONLY USDT [TRC20] TO THIS DEPOSIT ADDRESS</b><br/>Sending coin or token other than USDT (TRC20) to this address may result in the loss of your deposit. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														<div key="dash91" className="container__control--input" id="receiveusdtdisplay">
															
														</div>
														<div key="dash92" className="container__buttons">
															<button className="clipboard" id="receiveusdtproceed">$0.00</button>
														</div>		
													</div>
												</div>
												
												
												<div key="dash93" className="coinwrapper hide" id="bchwrapper">
													<div key="dash94" className="stack show" id="quicksellbch">
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableBCH1" dangerouslySetInnerHTML={{__html:`Bal: <b>0 BCH</b>`}}></p>
															<p>
																<b>SEND TO BANK ACCOUNT</b><br/>Your deposit needs to have at least 1 confirmation on blockchain to get payment to bank instantly, else it will queued until your deposit achieve the confirmation. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														
														<>
															<label id="quicksellbchdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="quicksellbchdir" id="quicksellbchdir" value={quicksellbchdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="quicksellbchdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash95" className="incsizespansms">
															<label htmlFor="quicksellsendall"><input type="checkbox" id="quicksellsendall" name="quicksellsendall" onClick={depositAllBCH} /> Sell Available BCH </label>
														</div>
														
														<div key="dash96" className="container__control--input">
															<input className="text-input" type="text" name="quicksellbchamount" id="quicksellbchamount" placeholder="Amount In USD" value={quicksellbchamount} onChange={(e) => setQuickSellBCHAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash97" className="incsizespan center" id="quicksellbchsummary">
															
														</div>	
														
														
														{verify === '1' ? (<div key="dash98" className="incsizespansms center" id="quicksellbchemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
														</div>) : (<div key="dash99" className="incsizespansms center" id="quicksellbchemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
														</div>)}
														
														<div key="dash100" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="quicksellbchconfirmationcode" id="quicksellbchconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password" />
															<span className="action_password icon-eye"></span>
														</div>
														<div key="dash101" className="incsizespan center" id="quicksellbchfeedback">	
														</div>
														<div key="dash102" className="container__buttons">
															<button className="clipboard" id="quicksellbchproceed" onClick={onSubmitQuickSellALT}>PROCEED</button>
														</div>
													</div>
													
													<div key="dash103" className="hide" id="sendbch">	
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableBCH2" dangerouslySetInnerHTML={{__html:`Bal: <b>0 BCH</b>`}}></p>
															<p>
																<b>MAKE SURE THE ADDRESS YOU HAVE PASTED IS THE SAME AS THE ADDRESS YOU HAVE COPIED!</b><br/>Some users have gotten their funds stolen by malware replacing the address copied to clipboard with the attackers address. <span className="tooltiplink">Learn more</span> 
															</p>
														</span>	
														
														<>
															<label id="sendbchdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="sendbchdir" id="sendbchdir" value={sendbchdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="sendbchdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash104" className="incsizespansms">
															<label htmlFor="sendbchsendall"><input type="checkbox" id="sendbchsendall" name="sendbchsendall" onClick={depositAllBCH} /> Send Available BCH </label>
														</div>
														
														<div key="dash105" className="container__control--input">
															<input className="text-input" type="text" name="sendbchamount" id="sendbchamount" placeholder="Amount In USD" value={sendbchamount} onChange={(e) => setSendBCHAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash106" className="incsizespan center" id="sendbchsummary">
															
														</div>
														
														<div key="dash107" className="container__control--input scan fixpost">
															<input className="text-input" type="text" name="sendbchaddress" id="sendbchaddress" placeholder="BCH Address" />
															<span id="sendbchcamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
														</div>								
														
														<div key="dash108" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="sendbchconfirmationcode" id="sendbchconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"  />
															<span className="action_password icon-eye"></span>
														</div>						
														
														<div key="dash109" className="incsizespan center" id="sendbchemailsummary">
															
														</div>	
														
														<div key="dash110" className="incsizespan center" id="sendbchfeedback">
															
														</div>
														
														<div key="dash111" className="container__buttons">
															<button className="clipboard" id="sendbchproceed" onClick={onSubmitSendALT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash112" className="hide" id="receivebch">	
													
														<span className="help-text">
															<p>
																<b>SEND ONLY BCH TO THIS DEPOSIT ADDRESS</b><br/>Sending coin or token other than BCH to this address may result in the loss of your deposit. <span className="tooltiplink">Learn more</span>
															</p>
														</span>	
														
														<div key="dash113" className="container__control--input" id="receivebchdisplay">
															
														</div>
														
														<div key="dash114" className="container__buttons">
															<button className="clipboard" id="receivebchproceed">$0.00</button>
														</div>														
													</div>
												
												</div>
												
												<div key="dash115" className="coinwrapper hide" id="ethwrapper">
													<div key="dash116" className="stack show" id="quickselleth">
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableETH1" dangerouslySetInnerHTML={{__html:`Bal: <b>0 ETH</b>`}}></p>
															<p>
																<b>SEND TO BANK ACCOUNT</b><br/>Your deposit needs to have at least 1 confirmation on blockchain to get payment to bank instantly, else it will queued until your deposit achieve the confirmation. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														
														<>
															<label id="quicksellethdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="quicksellethdir" id="quicksellethdir" value={quicksellethdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="quicksellethdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash117" className="incsizespansms">
															<label htmlFor="quicksellsendall"><input type="checkbox" id="quicksellsendall" name="quicksellsendall" onClick={depositAllETH} /> Sell Available ETH </label>
														</div>
														
														<div key="dash118" className="container__control--input">
															<input className="text-input" type="text" name="quicksellethamount" id="quicksellethamount" placeholder="Amount In USD" value={quicksellethamount} onChange={(e) => setQuickSellETHAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash119" className="incsizespan center" id="quicksellethsummary">
															
														</div>

														{verify === '1' ? (<div key="dash120" className="incsizespansms center" id="quicksellethemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
														</div>) : (<div key="dash121" className="incsizespansms center" id="quicksellethemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
														</div>)}
														
														
														<div key="dash122" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="quicksellethconfirmationcode" id="quicksellethconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password" />
															<span className="action_password icon-eye"></span>
														</div>		
														
														<div key="dash123" className="incsizespan center" id="quicksellethfeedback">
															
														</div>
														
														<div key="dash124" className="container__buttons">
															<button className="clipboard" id="quicksellethproceed" onClick={onSubmitQuickSellALT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash125" className="hide" id="sendeth">	
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableETH2" dangerouslySetInnerHTML={{__html:`Bal: <b>0 ETH</b>`}}></p>
															<p>															
																<b>MAKE SURE THE ADDRESS YOU HAVE PASTED IS THE SAME AS THE ADDRESS YOU HAVE COPIED!</b><br/>Some users have gotten their funds stolen by malware replacing the address copied to clipboard with the attackers address. <span className="tooltiplink">Learn more</span> 
															</p>
														</span>	
														
														<>
															<label id="sendethdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="sendethdir" id="sendethdir" value={sendethdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="sendethdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash126" className="incsizespansms">
															<label htmlFor="sendethsendall"><input type="checkbox" id="sendethsendall" name="sendethsendall" onClick={depositAllETH} /> Send Available ETH </label>
														</div>
														
														<div key="dash127" className="container__control--input">
															<input className="text-input" type="text" name="sendethamount" id="sendethamount" placeholder="Amount In USD" value={sendethamount} onChange={(e) => setSendETHAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash128" className="incsizespan center" id="sendethsummary">
															
														</div>
														
														<div key="dash129" className="container__control--input scan fixpost">
															<input className="text-input" type="text" name="sendethaddress" id="sendethaddress" placeholder="ETH Address" />
															<span id="sendethcamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
														</div>								
														
														<div key="dash130" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="sendethconfirmationcode" id="sendethconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"  />
															<span className="action_password icon-eye"></span>
														</div>						
														
														<div key="dash131" className="incsizespan center" id="sendethemailsummary">
															
														</div>	
														
														<div key="dash132" className="incsizespan center" id="sendethfeedback">
															
														</div>
														
														<div key="dash133" className="container__buttons">
															<button className="clipboard" id="sendethproceed" onClick={onSubmitSendALT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash134" className="hide" id="receiveeth">	
													
														<span className="help-text">
															<p>
																<b>SEND ONLY ETH TO THIS DEPOSIT ADDRESS</b><br/>Sending coin or token other than ETH to this address may result in the loss of your deposit. <span className="tooltiplink">Learn more</span>
															</p>
														</span>	
														
														<div key="dash135" className="container__control--input" id="receiveethdisplay">
															
														</div>
														
														<div key="dash136" className="container__buttons">
															<button className="clipboard" id="receiveethproceed">$0.00</button>
														</div>														
													</div>
												
												</div>
												
												
												<div key="dash137" className="coinwrapper hide" id="ltcwrapper">
													<div key="dash138" className="stack show" id="quicksellltc">
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableLTC1" dangerouslySetInnerHTML={{__html:`Bal: <b>0 LTC</b>`}}></p>
															<p>
																<b>SEND TO BANK ACCOUNT</b><br/>Your deposit needs to have at least 1 confirmation on blockchain to get payment to bank instantly, else it will queued until your deposit achieve the confirmation. <span className="tooltiplink">Learn more</span>
															</p>
														</span>
														
														<>
															<label id="quicksellltcdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="quicksellltcdir" id="quicksellltcdir" value={quicksellltcdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="quicksellltcdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash139" className="incsizespansms">
															<label htmlFor="quicksellsendall"><input type="checkbox" id="quicksellsendall" name="quicksellsendall" onClick={depositAllLTC} /> Sell Available LTC </label>
														</div>
														
														<div key="dash140" className="container__control--input">
															<input className="text-input" type="text" name="quicksellltcamount" id="quicksellltcamount" placeholder="Amount In USD" value={quicksellltcamount} onChange={(e) => setQuickSellLTCAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash141" className="incsizespan center" id="quicksellltcsummary">
															
														</div>	
														
														{verify === '1' ? (<div key="dash142" className="incsizespansms center" id="quicksellltcemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}>				
														</div>) : (<div key="dash143" className="incsizespansms center" id="quicksellltcemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}>				
														</div>)}
												
														
														<div key="dash144" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="quicksellltcconfirmationcode" id="quicksellltcconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password" />
															<span className="action_password icon-eye"></span>
														</div>		
														
														<div key="dash145" className="incsizespan center" id="quicksellltcfeedback">
															
														</div>
														
														<div key="dash146" className="container__buttons">
															<button className="clipboard" id="quicksellltcproceed" onClick={onSubmitQuickSellALT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash147" className="hide" id="sendltc">	
													
														<span className="help-text">
															<p className="text-uppercase available" id="availableLTC2" dangerouslySetInnerHTML={{__html:`Bal: <b>0 LTC</b>`}}></p>
															<p>
																<b>MAKE SURE THE ADDRESS YOU HAVE PASTED IS THE SAME AS THE ADDRESS YOU HAVE COPIED!</b><br/>Some users have gotten their funds stolen by malware replacing the address copied to clipboard with the attackers address. <span className="tooltiplink">Learn more</span> 
															</p>
														</span>	
														
														<>
															<label id="sendltcdirswitch" style={{left:'calc(50% - 40px)', position: 'relative'}}>
															<span className="switch__text"></span>
															<input className="switch__checkbox" type="checkbox" name="sendltcdir" id="sendltcdir" value={sendltcdir} onChange={handleSwitchChange2} tabIndex="1" />
															
															
															<span className="switch__elements" aria-hidden="true">
																<span className="switch__inner">
																	<span className="switch__left" id="sendltcdirdisplay"></span>
																	<span className="switch__right">USD</span>
																	<span className="switch__middle"></span>
																</span>
															</span>
															</label>
														</>
														
														<div key="dash148" className="incsizespansms">
															<label htmlFor="sendltcsendall"><input type="checkbox" id="sendltcsendall" name="sendltcsendall" onClick={depositAllLTC} /> Send Available LTC </label>
														</div>
														
														<div key="dash149" className="container__control--input">
															<input className="text-input" type="text" name="sendltcamount" id="sendltcamount" placeholder="Amount In USD" value={sendltcamount} onChange={(e) => setSendLTCAmount(e.target.value)} onKeyUp={handleKeyUp} />
														</div>
														
														<div key="dash150" className="incsizespan center" id="sendltcsummary">
															
														</div>
														
														<div key="dash151" className="container__control--input scan fixpost">
															<input className="text-input" type="text" name="sendltcaddress" id="sendltcaddress" placeholder="LTC Address" />
															<span id="sendltccamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
														</div>								
														
														<div key="dash152" className="container__control--input password fixpost">
															<input className="text-input" type="password" name="sendltcconfirmationcode" id="sendltcconfirmationcode" placeholder="Confirmation Code" maxLength="6" autoComplete="new-password"  />
															<span className="action_password icon-eye"></span>
														</div>						
														
														<div key="dash153" className="incsizespan center" id="sendltcemailsummary">
															
														</div>	
														
														<div key="dash154" className="incsizespan center" id="sendltcfeedback">
															
														</div>
														
														<div key="dash155" className="container__buttons">
															<button className="clipboard" id="sendltcproceed" onClick={onSubmitSendALT}>PROCEED</button>
														</div>
														
													</div>
													
													<div key="dash156" className="hide" id="receiveltc">	
													
														<span className="help-text">
															<p>
																<b>SEND ONLY LTC TO THIS DEPOSIT ADDRESS</b><br/>Sending coin or token other than LTC to this address may result in the loss of your deposit. <span className="tooltiplink">Learn more</span>
															</p>
														</span>	
														
														<div key="dash157" className="container__control--input" id="receiveltcdisplay">
															
														</div>
														
														<div key="dash158" className="container__buttons">
															<button className="clipboard" id="receiveltcproceed">$0.00</button>
														</div>
														
													</div>
												
												</div>
											</div>
										</div>
										
									</div>
								</div>
							</div>
						</div>						
					</div>
					
					<div key="dash28t" className="acc__item" id="acc__item3">
						<div key="dash29t" className="acc__toggler" id="acc__toggler3" onClick={handleClick3}>
							<div key="dash30t" className="payment-name">
								<div key="dash31t" className="pname">TRADE [SELL, BUY & DEPOSIT]</div> 
								<div key="dash32t" className="pimg"><img src={CRYPTOLogo} alt="Crypto trade" className="img-responsive acc__toggler-icons"/></div>
							</div>
						</div> 
						<div key="dash33t" className="acc__content">
							<div key="dash34t" className="po-wrap">
								<div key="dash35t" className="po-crypto__step-1">			
								
								<div key="dash159" className="[ stack ] [ container__controls2 ]" id="dv1">
								<div key="dash160" className="container__control--switch">
									<TradeSwitch />
								</div>						
								
								<div key="dash161" className="stack disshow" id="selldisplay">
									<div key="dash162" style={center}>
										<h6 style={lineOne} >SELL TO ENDOPAY</h6>
										<b><Link to="/" id="HOWTOSELL" style={lineTwo}>CLICK HERE TO SEE HOW TO SELL</Link></b><br/>
										<h4 style={lineThree}>Rate: <span id="sellratedisplay" style={redColor} ></span> | Min: <span id="minselldisplay" style={redColor} ></span> | Max: <span id="maxselldisplay" style={redColor} ></span></h4>
									</div>
									
									<>
										<label id="sellcurrencydirswitch" style={{left:'calc(50% - 40px)'}}>
										<span className="switch__text"></span>
										<input className="switch__checkbox" type="checkbox" name="sellcurrencydir" id="sellcurrencydir" value={sellcurrencydir} onChange={handleSwitchChange} tabIndex="1" />
										<span className="switch__elements" aria-hidden="true">
											<span className="switch__inner">
												<span className="switch__left" id="sellcurrencydirdisplay"></span>
												<span className="switch__right">USD</span>
												<span className="switch__middle"></span>
											</span>
										</span>
										</label>
									</>
									
									<div key="dash163" className="container__control--select">
										<select className="select-input" name="sellcurrency" id="sellcurrency" value={sellcurrency} onChange={(e) => setSellCurrency(e.target.value)}>
											<option value="">Select Currency</option>
											<option value="BTC">BTC - Bitcoin</option>
											<option value="USDT">USDT - Tether (TRC20)</option>
											<option value="PM">PM - Perfect Money</option>
											<option value="BCH">BCH - Bitcoin Cash</option>
											<option value="ETH">ETH - Ethereum</option>
											<option value="LTC">LTC - Litecoin</option>
										</select>
									</div>
									
									<div key="dash164" className="container__control--input">
										<input className="text-input" type="text" name="sellamount" id="sellamount" placeholder="Amount In USD" value={sellamount} onChange={(e) => setSellAmount(e.target.value)} onKeyUp={handleKeyUp}/>
									</div>
									
									<div key="dash165" className="incsizespan center" id="sellsummary">					
									</div>
									
									{verify === '1' ? (<div key="dash166" className="incsizespansms center" id="sellemailsummary"  dangerouslySetInnerHTML={{__html: `<b>Account Resolved</b><br/>Bank Name: <b>${dashboardparams.bankabbr}</b><br/>Bank Account: <b>${dashboardparams.bankacct}</b><br/><span style="color: #fff; text-decoration: underline; cursor: pointer" onclick="switchBank()">Switch Bank Account</span>`}}></div>) : (<div key="dash167" className="incsizespansms center" id="sellemailsummary"  dangerouslySetInnerHTML={{__html: `<a href='/bank'><b>Account Bank Details</b></a>`}}></div>)}
									
									<div key="dash168" className="container__control--input hide" id="sellbankinfo1">
										<input className="text-input" type="text" id="sellbankaccount" placeholder="Bank Account Number" onKeyUp={handleFetchBank} />
										<input type="hidden" id="sellbankaccountname" value=""/>
									</div>
									<div key="dash169" className="container__control--select hide" id="sellbankinfo2">
										<select
											className="select-input" 
											name="sellbankname" 
											id="sellbankname" 
											onChange={handleFetchBank}
										>
											{bankOptions.map((group) => (
												<optgroup key={group?.label} label={group?.label}>
													{group?.options.map((option) => (
														<option key={option.value} value={option.value}>
															{option?.label}
														</option>
													))}
												</optgroup>
											))}
										</select>															
									</div>
									
									<div key="dash170" className="incsizespan center hide" id="sellbanksummary">
										
									</div>
									
									<div key="dash171" className="container__control--input hide" id="sellbankinfo3">
										<input className="text-input" type="text" id="sellemailcode" placeholder="Email Code" onKeyUp={handleKeyUp}/>
									</div>	
									
									<div key="dash172" className="incsizespan hide" id="sellsmswrap">
										<label htmlFor="sellsms"><input type="checkbox" id="sellsms" onClick={onPhoneSMS} /> Receive SMS on Completion <b>₦10</b></label>
									</div>
									
									<div key="dash173" className="container__control--input hide" id="sellsmsphonewrap">
										<input className="text-input" type="text" id="sellsmsphone" placeholder="Phone Number" maxLength="14" onKeyUp={handlePhoneSMS}/>
									</div>
									
									<div key="dash174" className="incsizespan center" id="sellfeedback">
										
									</div>
									
									<div key="dash175" className="container__buttons">
										<button className="clipboard" id="sellproceed" onClick={onSubmitSell}>PROCEED</button>
									</div>
								</div>
								
								<div key="dash176" className="stack animatehide" id="buydisplay">
									<div key="dash177" style={center}>
										<h6 style={lineOne} >BUY FROM ENDOPAY</h6>
										<b><Link to="/" id="HOWTOBUY" style={lineTwo}>CLICK HERE TO SEE HOW TO BUY</Link></b><br/>
										<h4 style={lineThree}>Rate: <span id="buyratedisplay" style={redColor} ></span> | Min: <span id="minbuydisplay" style={redColor} ></span> | Max: <span id="maxbuydisplay" style={redColor} ></span></h4>
									</div>
									
									<>
										<label id="buycurrencydirswitch" style={{left:'calc(50% - 40px)'}}>
										<span className="switch__text"></span>
										<input className="switch__checkbox" type="checkbox" name="buycurrencydir" id="buycurrencydir" value={buycurrencydir} onChange={handleSwitchChange} tabIndex="1" />
										<span className="switch__elements" aria-hidden="true">
											<span className="switch__inner">
												<span className="switch__left" id="buycurrencydirdisplay"></span>
												<span className="switch__right">USD</span>
												<span className="switch__middle"></span>
											</span>
										</span>
										</label>
									</>
									
									<div key="dash178eth" className="incsizespan center" id="buyeth">
										
									</div>
									
									<div key="dash178" className="container__control--select">
										<select className="select-input" name="buycurrency" id="buycurrency" value={buycurrency} onChange={(e) => setBuyCurrency(e.target.value)} >
											<option value="">Select Currency</option>
											<option value="BTC">BTC - Bitcoin</option>
											<option value="USDT">USDT - Tether (TRC20)</option>
											<option value="PM">PM - Perfect Money</option>
											<option value="BCH">BCH - Bitcoin Cash</option>
											<option value="ETH">ETH - Ethereum</option>
											<option value="LTC">LTC - Litecoin</option>
											<option value="GP">GP - Google Play Card</option>
											<option value="IT">IT - ITunes Gift Card</option>
										</select>
									</div>
									
									<div key="dash179" className="container__control--select">
										<select className="select-input" name="buymethod" id="buymethod" value={buymethod} onChange={(e) => setBuyMethod(e.target.value)}>
											<option value="">Select Payment Method</option>
											<option value="CC">Debit Card</option>
											<option value="BT">Bank Transfer</option>
											<option value="BT">Cash Deposit</option>
											<option value="EN">Endopay Account</option>
										</select>
									</div>
									
									<div key="dash180" className="container__control--input">
										<input className="text-input" type="text" name="buyamount" id="buyamount" placeholder="Amount In USD" value={buyamount} onChange={(e) => setBuyAmount(e.target.value)} onKeyUp={handleKeyUp} />
									</div>
									
									<div key="dash181" className="incsizespan center" id="buysummary">
										
									</div>
									
									<div key="dash182" className="container__control--input scan fixpost">
										<input className="text-input" type="text" name="buyaccount" id="buyaccount" placeholder="Receive Account" onKeyUp={handleKeyUp} />
										<span id="buyaccountcamera" className="camera icon-camera" onMouseDown={ScanQR}></span>
									</div>				
										
									<div key="dash183" className="incsizespan center" id="buyaccountsummary">
										
									</div>
									
									<div key="dash184" className="incsizespansms center" id="buyemailsummary">
										{verify === '1' ? (<b>Account Resolved</b>) : (<a href='/bank'><b>Account Bank Details</b></a>)}
									</div>	
									
									<div key="dash185" id="buycodewrap" className="container__control--input password fixpost hide">
										<input className="text-input" type="password" name="buycode" id="buycode" placeholder="Confirmation Code" autoComplete="new-password" />
										<span className="action_password icon-eye"></span>
									</div>

									<div key="dash186" className="incsizespansms">
										<label htmlFor="buysms"><input type="checkbox" id="buysms" /> Receive SMS on Completion <b>₦10</b></label>
									</div>
									
									<div key="dash187" className="incsizespan center" id="buyfeedback">
										
									</div>
									
									<div key="dash188" className="container__buttons">
										<button className="clipboard" id="buyproceed" onClick={onSubmitBuy}>PROCEED</button>
									</div>
								</div>
								
								
								
								<div key="dash189" className="stack animatehide" id="depositdisplay">
									<div key="dash190" style={center}>
										<h6 style={lineOne} >FUND ENDOPAY ACCOUNT</h6>
										<b><Link to="/" id="HOWTODEPOSIT" style={lineTwo}>CLICK HERE TO SEE HOW TO DEPOSIT</Link></b><br/>
										<h4 style={lineThree}>Rate: <span id="depositratedisplay" style={redColor} ></span> | Min: <span id="mindepositdisplay" style={redColor} ></span> | Max: <span id="maxdepositdisplay" style={redColor} ></span></h4>			
									</div>
									
									
									<>
										<label id="depositcurrencydirswitch" style={{left:'calc(50% - 40px)'}}>
										<span className="switch__text"></span>
										<input className="switch__checkbox" type="checkbox" name="depositcurrencydir" id="depositcurrencydir" value={depositcurrencydir} onChange={handleSwitchChange} tabIndex="1" />
										<span className="switch__elements" aria-hidden="true">
											<span className="switch__inner">
												<span className="switch__left" id="depositcurrencydirdisplay"></span>
												<span className="switch__right">USD</span>
												<span className="switch__middle"></span>
											</span>
										</span>
										</label>
									</>
													
									<div key="dash191" className="container__control--select">
										<select className="select-input" name="depositcurrency" id="depositcurrency" value={depositcurrency} onChange={(e) => setDepositCurrency(e.target.value)}>
											<option value="">Select Currency</option>
											<option value="CC">Debit Card</option>
											<option value="BT">Bank Transfer</option>
											<option value="BTCEN">BTC - Bitcoin [Endopay]</option>
											<option value="BTC">BTC - Bitcoin [Other]</option>
											<option value="USDT">USDT - Tether (TRC20)</option>
											<option value="PM">PM - Perfect Money</option>
											<option value="BCH">BCH - Bitcoin Cash</option>
											<option value="ETH">ETH - Ethereum</option>
											<option value="LTC">LTC - Litecoin</option>
										</select>
									</div>
									
									<div key="dash192" className="container__control--input">
										<input className="text-input" type="text" name="depositamount" id="depositamount" placeholder="Amount In USD" value={depositamount} onChange={(e) => setDepositAmount(e.target.value)} onKeyUp={handleKeyUp} />
									</div>
									
									<div key="dash193" className="incsizespan center" id="depositsummary">
										
									</div>	

									<div key="dash194" className="incsizespansms center" id="depositemailsummary">
										{verify === '1' ? (<b>Account Resolved</b>) : (<a href='/bank'><b>Account Bank Details</b></a>)}
									</div>
									
									<div key="dash195" id="depositcodewrap" className="container__control--input password fixpost hide">
										<input className="text-input" type="password" name="depositcode" id="depositcode" placeholder="Confirmation Code" autoComplete="new-password" />
										<span className="action_password icon-eye"></span>
									</div>

									<div key="dash196" className="incsizespansms">
										<label htmlFor="depositsms"><input type="checkbox" id="depositsms" /> Receive SMS on Completion <b>₦10</b></label>
									</div>	
									
									<div key="dash197" className="incsizespan center" id="depositfeedback">
										
									</div>
									
									<div key="dash198" className="container__buttons">
										<button className="clipboard" id="depositproceed" onClick={onSubmitDeposit}>PROCEED</button>
									</div>
								</div>
								
								</div>
							</div>
						</div>
					</div>
					
				</div>
			</div>
			
		</div>			
		</div>
		</div>

		),		
		(
			<DashboardParam key="dv5" dashboardparam={dashboardparams}/>
		)
		]
	}
}

const lineOne = {
   fontSize: '15px',
   color: '#d13529',
   lineHeight: '25px',
   fontWeight: '500'
}
const lineTwo = {
   fontSize: '15px',
   lineHeight: '45px',
   fontWeight: '500'
}
const lineThree = {
   fontSize: '15px',
   lineHeight: '25px',
   fontWeight: '500'
}
const redColor = {
   color: '#d13529',
}
const rectStyleWrap = {
   minWidth: '250px',
   gridColumn: 1
}
const center = {
   textAlign: 'center'   
}
export default DashboardView;